@if (isSubmitted) {
  <div class="page-layout">
    <div class="submission-success-card">
      <div class="success-icon">
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="32" fill="#334ea5" fill-opacity="0.1" />
          <circle cx="32" cy="32" r="24" fill="#334ea5" fill-opacity="0.2" />
          <path
            d="M20 32L28 40L44 24"
            stroke="#334ea5"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h2 class="success-title">
        {{
          "GENERAL_OUTREACH_FORM.MESSAGES.SUBMISSION_SUCCESS_TITLE" | translate
        }}
      </h2>

      <p class="success-message">
        @if (form.optOutCommunications) {
          {{
            "GENERAL_OUTREACH_FORM.MESSAGES.SUBMISSION_SUCCESS_OPT_OUT"
              | translate
          }}
        } @else {
          {{ "GENERAL_OUTREACH_FORM.MESSAGES.SUBMISSION_SUCCESS" | translate }}
        }
      </p>

      @if (isPollingMatches) {
        <div class="polling-loader-container">
          <div class="loader-spinner">
            <svg viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20"></circle>
            </svg>
          </div>
          <h3 class="polling-title">
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.SEARCHING_MATCHES_TITLE"
                | translate
            }}
          </h3>
          <p class="polling-submessage">
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.POLLING_SUBMESSAGE" | translate
            }}
          </p>

          <div class="matching-notice-callout">
            <div class="notice-icon" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </div>
            <div class="notice-content">
              <p class="notice-text">
                {{
                  "GENERAL_OUTREACH_FORM.MESSAGES.PUBLIC_MATCHED_CDFIS_EMAIL_TEXT"
                    | translate
                }}
              </p>
            </div>
          </div>

          @if (
            pollingMessage &&
            (pollingMessage.includes("Unable") ||
              pollingMessage.includes("unable") ||
              pollingMessage.includes("No se pueden"))
          ) {
            <p class="polling-error">{{ pollingMessage }}</p>
          }
        </div>
      }

      @if (matchedConnections.length > 0 && !isPollingMatches) {
        <div class="matched-connections-section">
          <div class="connections-header">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                stroke="#334ea5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                cx="9"
                cy="7"
                r="4"
                stroke="#334ea5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                stroke="#334ea5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h3>
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.MATCHED_CONNECTIONS"
                  | translate
                    : {
                        count: matchedConnections.length,
                        org: matchedConnections.length > 1 ? "s" : "",
                      }
              }}
            </h3>
          </div>
          <ul class="connections-list">
            @for (connection of matchedConnections; track connection) {
              <li>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="10"
                    fill="#334ea5"
                    fill-opacity="0.15"
                  />
                  <path
                    d="M6 10l3 3 5-6"
                    stroke="#334ea5"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ connection }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>

    <!-- Portal Invitation Banner (moved from below feedback card) -->
    <div class="portal-invite-card">
      <div class="portal-invite-header">
        <h3 class="portal-invite-title">
          {{ "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_TITLE" | translate }}
        </h3>
        <p class="portal-invite-subtitle">
          {{
            "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_SUBTITLE" | translate
          }}
        </p>
      </div>

      <div class="portal-features-grid">
        <div class="portal-feature-item">
          <div class="portal-feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
          </div>
          <div>
            <div class="portal-feature-title">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_1_TITLE"
                  | translate
              }}
            </div>
            <div class="portal-feature-desc">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_1_DESC"
                  | translate
              }}
            </div>
          </div>
        </div>

        <div class="portal-feature-item">
          <div class="portal-feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div>
            <div class="portal-feature-title">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_2_TITLE"
                  | translate
              }}
            </div>
            <div class="portal-feature-desc">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_2_DESC"
                  | translate
              }}
            </div>
          </div>
        </div>

        <div class="portal-feature-item">
          <div class="portal-feature-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <div>
            <div class="portal-feature-title">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_3_TITLE"
                  | translate
              }}
            </div>
            <div class="portal-feature-desc">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_3_DESC"
                  | translate
              }}
            </div>
          </div>
        </div>

        <div class="portal-feature-item">
          <div class="portal-feature-icon portal-feature-icon--active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <div>
            <div class="portal-feature-title">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_4_TITLE"
                  | translate
              }}
            </div>
            <div class="portal-feature-desc">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_FEATURE_4_DESC"
                  | translate
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="portal-invite-actions">
        @if (!smeEmailSent) {
          @if (smeSignupError) {
            <p class="portal-signup-error">{{ smeSignupError }}</p>
          }
          <button
            type="button"
            class="portal-join-btn"
            [disabled]="smeSignupLoading"
            (click)="onJoinNow()"
          >
            @if (smeSignupLoading) {
              <span class="btn-spinner"></span>
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_SENDING"
                  | translate
              }}
            } @else {
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_CTA" | translate
              }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            }
          </button>
        } @else {
          <!-- Email sent success state inside action area -->
          <div class="portal-email-sent">
            <div class="portal-email-sent-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <div class="portal-email-sent-content">
              <h4 class="portal-email-sent-title">
                {{
                  "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_EMAIL_SENT_TITLE"
                    | translate
                }}
              </h4>
              <p class="portal-email-sent-subtitle">
                {{
                  "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_EMAIL_SENT_DESC"
                    | translate
                }}
              </p>
              <div class="portal-email-sent-steps">
                <div class="sent-step">
                  <span class="sent-step-num">1</span>
                  <span>{{
                    "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_STEP_1"
                      | translate
                  }}</span>
                </div>
                <div class="sent-step">
                  <span class="sent-step-num">2</span>
                  <span>{{
                    "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_STEP_2"
                      | translate
                  }}</span>
                </div>
                <div class="sent-step">
                  <span class="sent-step-num">3</span>
                  <span>{{
                    "GENERAL_OUTREACH_FORM.MESSAGES.PORTAL_INVITE_STEP_3"
                      | translate
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Feedback Popup Overlay -->
@if (showFeedbackPopup) {
  <div
    class="feedback-popup-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="feedback-popup-heading"
  >
    <div class="feedback-popup-panel">
      @if (!feedbackSubmitted) {
        <!-- Header with small success badge -->
        <div class="feedback-popup-header">
          <div class="feedback-popup-badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <!--!Font Awesome Free v7.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
              <path
                d="M320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304C64 358.3 83.2 408.3 115.6 448.5L66.8 540.8C62 549.8 63.5 560.8 70.4 568.3C77.3 575.8 88.2 578.1 97.5 574.1L215.9 523.4C247.7 536.6 282.9 544 320 544zM192 272C209.7 272 224 286.3 224 304C224 321.7 209.7 336 192 336C174.3 336 160 321.7 160 304C160 286.3 174.3 272 192 272zM320 272C337.7 272 352 286.3 352 304C352 321.7 337.7 336 320 336C302.3 336 288 321.7 288 304C288 286.3 302.3 272 320 272zM416 304C416 286.3 430.3 272 448 272C465.7 272 480 286.3 480 304C480 321.7 465.7 336 448 336C430.3 336 416 321.7 416 304z"
              />
            </svg>
          </div>
          <div class="feedback-popup-heading-group">
            <h3 id="feedback-popup-heading" class="feedback-popup-title">
              {{ "GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_TITLE" | translate }}
            </h3>
            <p class="feedback-popup-subtitle">
              {{
                "GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_SUBTITLE" | translate
              }}
            </p>
          </div>
        </div>

        <!-- Face ratings -->
        <div
          class="feedback-popup-ratings"
          role="group"
          aria-label="Rate your experience"
        >
          @for (star of stars; track star) {
            <button
              type="button"
              class="face-rating-button"
              [class.selected]="star === rating"
              [disabled]="submittingFeedback"
              (click)="setRating(star)"
              [attr.aria-label]="
                'GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_RATING_ARIA'
                  | translate: { value: star }
              "
              [title]="
                'GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_RATING_ARIA'
                  | translate: { value: star }
              "
            >
              @switch (star) {
                @case (1) {
                  <svg
                    class="face-icon face-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM240.5 384.3C260.1 366.1 287.8 352 320 352C352.2 352 379.9 366.1 399.5 384.3C418.5 402.1 432 426 432 448C432 453.4 429.3 458.4 424.8 461.4C420.3 464.4 414.6 464.8 409.6 462.7L392.4 455.2C369.6 445.2 344.9 440.1 320 440.1C295.1 440.1 270.4 445.3 247.6 455.2L230.4 462.7C225.5 464.9 219.7 464.4 215.2 461.4C210.7 458.4 208 453.4 208 448C208 426 221.5 402.1 240.5 384.3zM186.6 223.2C191.1 216.4 199.9 214 207.2 217.7L286.8 257.7C292.2 260.4 295.6 265.9 295.6 272C295.6 278.1 292.2 283.6 286.8 286.3L207.2 326.3C199.9 329.9 191.1 327.6 186.6 320.8C182.1 314 183.5 304.9 189.7 299.7L223 272L189.8 244.3C183.6 239.1 182.2 230 186.7 223.2zM450.2 244.3L417 272L450.2 299.7C456.4 304.9 457.8 314 453.3 320.8C448.8 327.6 440 330 432.7 326.3L353.1 286.3C347.7 283.6 344.3 278.1 344.3 272C344.3 265.9 347.7 260.4 353.1 257.7L432.7 217.7C440 214.1 448.8 216.4 453.3 223.2C457.8 230 456.4 239.1 450.2 244.3z"
                    />
                  </svg>
                }
                @case (2) {
                  <svg
                    class="face-icon face-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM398.7 448.6C383.7 433 357.6 416 320 416C282.4 416 256.3 433 241.3 448.6C232.1 458.2 216.9 458.5 207.4 449.3C197.9 440.1 197.5 424.9 206.7 415.4C228.8 392.4 266.7 368 320 368C373.3 368 411.2 392.4 433.3 415.4C442.5 425 442.2 440.2 432.6 449.3C423 458.4 407.8 458.2 398.7 448.6zM208 272C208 254.3 222.3 240 240 240C257.7 240 272 254.3 272 272C272 289.7 257.7 304 240 304C222.3 304 208 289.7 208 272zM400 240C417.7 240 432 254.3 432 272C432 289.7 417.7 304 400 304C382.3 304 368 289.7 368 272C368 254.3 382.3 240 400 240z"
                    />
                  </svg>
                }
                @case (3) {
                  <svg
                    class="face-icon face-3"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M528 320C528 434.9 434.9 528 320 528C205.1 528 112 434.9 112 320C112 205.1 205.1 112 320 112C434.9 112 528 205.1 528 320zM320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64zM240 304C257.7 304 272 289.7 272 272C272 254.3 257.7 240 240 240C222.3 240 208 254.3 208 272C208 289.7 222.3 304 240 304zM432 272C432 254.3 417.7 240 400 240C382.3 240 368 254.3 368 272C368 289.7 382.3 304 400 304C417.7 304 432 289.7 432 272zM248 384C234.7 384 224 394.7 224 408C224 421.3 234.7 432 248 432L392 432C405.3 432 416 421.3 416 408C416 394.7 405.3 384 392 384L248 384z"
                    />
                  </svg>
                }
                @case (4) {
                  <svg
                    class="face-icon face-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM241.3 383.4C256.3 399 282.4 416 320 416C357.6 416 383.7 399 398.7 383.4C407.9 373.8 423.1 373.5 432.6 382.7C442.1 391.9 442.5 407.1 433.3 416.6C411.2 439.6 373.3 464 320 464C266.7 464 228.8 439.6 206.7 416.6C197.5 407 197.8 391.8 207.4 382.7C217 373.6 232.2 373.8 241.3 383.4zM208 272C208 254.3 222.3 240 240 240C257.7 240 272 254.3 272 272C272 289.7 257.7 304 240 304C222.3 304 208 289.7 208 272zM400 240C417.7 240 432 254.3 432 272C432 289.7 417.7 304 400 304C382.3 304 368 289.7 368 272C368 254.3 382.3 240 400 240z"
                    />
                  </svg>
                }
                @case (5) {
                  <svg
                    class="face-icon face-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM436.2 366.3C448 362.7 459.9 372.4 455.8 384.1C436 440 382.7 480.1 320 480.1C257.3 480.1 204 440.1 184.2 384.2C180.1 372.6 192 362.8 203.8 366.4C238.5 377 278 382.9 319.9 382.9C361.9 382.9 401.4 376.9 436.2 366.3zM208 272C208 254.3 222.3 240 240 240C257.7 240 272 254.3 272 272C272 289.7 257.7 304 240 304C222.3 304 208 289.7 208 272zM400 240C417.7 240 432 254.3 432 272C432 289.7 417.7 304 400 304C382.3 304 368 289.7 368 272C368 254.3 382.3 240 400 240z"
                    />
                  </svg>
                }
              }
            </button>
          }
        </div>

        <!-- Optional comment -->
        <textarea
          class="feedback-popup-textarea"
          rows="3"
          [(ngModel)]="comment"
          [disabled]="submittingFeedback"
          placeholder="{{
            'GENERAL_OUTREACH_FORM.PLACEHOLDERS.COMMENTS' | translate
          }}"
        ></textarea>

        @if (feedbackError) {
          <p class="feedback-error-message">{{ feedbackError }}</p>
        }

        <!-- Actions -->
        <div class="feedback-popup-actions">
          <button
            type="button"
            class="feedback-popup-skip-btn"
            (click)="closeFeedbackPopup()"
          >
            Skip
          </button>
          <button
            type="button"
            class="feedback-popup-submit-btn"
            [disabled]="rating === 0 || submittingFeedback"
            (click)="submitFeedback()"
          >
            @if (submittingFeedback) {
              <span class="spinner"></span>
              {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMITTING" | translate }}
            } @else {
              <span>{{
                "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT_FEEDBACK" | translate
              }}</span>
            }
          </button>
        </div>
      } @else {
        <!-- Thank-you state -->
        <div class="feedback-popup-thanks">
          <div class="feedback-thanks-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path
                d="M235.5 102.8C256.3 68 300.5 54 338 71.6L345.2 75.4C380 96.3 394 140.5 376.4 178L376.4 178L362.3 208L472 208L479.4 208.4C515.7 212.1 544 242.8 544 280C544 293.2 540.4 305.4 534.2 316C540.3 326.6 543.9 338.8 544 352C544 370.3 537.1 386.8 526 399.5C527.3 404.8 528 410.3 528 416C528 441.1 515.1 463 495.8 475.9C493.9 511.4 466.4 540.1 431.4 543.6L424 544L319.9 544C301.9 544 284 540.6 267.3 534.1L260.2 531.1L259.5 530.8L252.9 527.6L252.2 527.3L240 520.8C227.7 514.3 216.7 506.1 207.1 496.7C203 523.6 179.8 544.1 151.8 544.1L119.8 544.1C88.9 544.1 63.8 519 63.8 488.1L64 264C64 233.1 89.1 208 120 208L152 208C162.8 208 172.9 211.1 181.5 216.5L231.6 110L232.2 108.8L234.9 103.8L235.5 102.9zM120 256C115.6 256 112 259.6 112 264L112 488C112 492.4 115.6 496 120 496L152 496C156.4 496 160 492.4 160 488L160 264C160 259.6 156.4 256 152 256L120 256zM317.6 115C302.8 108.1 285.3 113.4 276.9 127L274.7 131L217.9 251.9C214.4 259.4 212.4 267.4 211.9 275.6L211.8 279.8L211.8 392.7L212 400.6C214.4 433.3 233.4 462.7 262.7 478.3L274.2 484.4L280.5 487.5C292.9 493.1 306.3 496 319.9 496L424 496L426.4 495.9C438.5 494.7 448 484.4 448 472L447.8 469.4C447.7 468.5 447.6 467.7 447.4 466.8C444.7 454.7 451.7 442.6 463.4 438.8C473.1 435.7 480 426.6 480 416C480 411.7 478.9 407.8 476.9 404.2C470.6 393.1 474.1 379 484.9 372.2C491.7 367.9 496.1 360.4 496.1 352C496.1 344.9 493 338.5 487.9 334C482.7 329.4 479.7 322.9 479.7 316C479.7 309.1 482.7 302.6 487.9 298C493 293.5 496.1 287.1 496.1 280L496 277.6C494.9 266.3 485.9 257.3 474.6 256.2L472.2 256.1L324.7 256.1C316.5 256.1 308.9 251.9 304.5 245C300.1 238.1 299.5 229.3 303 221.9L333 157.6C340 142.6 334.4 124.9 320.5 116.6L317.6 115z"
              />
            </svg>
          </div>
          <h4>
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_THANK_YOU_TITLE"
                | translate
            }}
          </h4>
          <p>
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.FEEDBACK_THANK_YOU_SUBTITLE"
                | translate
            }}
          </p>
          <button
            type="button"
            class="feedback-popup-done-btn"
            (click)="closeFeedbackPopup()"
          >
            Done
          </button>
        </div>
      }
    </div>
  </div>
}

@if (isNoInterestSubmitted) {
  <div class="page-layout">
    <div class="form-container" style="padding-top: 1px">
      <p class="submission-message">
        {{ "GENERAL_OUTREACH_FORM.MESSAGES.NO_INTEREST_MESSAGE" | translate }}
      </p>

      <div class="form-actions">
        <button
          type="button"
          (click)="restartForm()"
          class="back-button"
          style="margin-bottom: 25px; margin-left: auto"
        >
          {{ "GENERAL_OUTREACH_FORM.BUTTONS.RESTART_FORM" | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (!isSubmitted && !isNoInterestSubmitted) {
  <div class="page-layout" [class.demo-static-form]="isDemoMode">
    <div class="form-container">
      <!-- Language Toggle Switch -->
      <div class="language-toggle-container">
        <div
          class="language-toggle-switch"
          [attr.aria-label]="
            'GENERAL_OUTREACH_FORM.LANGUAGE_TOGGLE' | translate
          "
        >
          <div class="language-options">
            <button
              type="button"
              class="language-option"
              [class.active]="currentLanguage === 'en'"
              (click)="currentLanguage !== 'en' && toggleLanguage()"
              [attr.aria-pressed]="currentLanguage === 'en'"
            >
              <span class="language-code">EN</span>
              <span class="language-name">English</span>
            </button>
            <button
              type="button"
              class="language-option"
              [class.active]="currentLanguage === 'es'"
              (click)="currentLanguage !== 'es' && toggleLanguage()"
              [attr.aria-pressed]="currentLanguage === 'es'"
            >
              <span class="language-code">ES</span>
              <span class="language-name">Español</span>
            </button>
          </div>
          <div
            class="toggle-slider"
            [class.spanish]="currentLanguage === 'es'"
          ></div>
        </div>
      </div>

      <div class="form-header">
        <div class="header-content">
          <div class="form-title">
            {{ "GENERAL_OUTREACH_FORM.TITLE" | translate }}
          </div>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" class="general-form">
        <!--
          FIELD TRACKING FOR DROP-OFF ANALYSIS
          Field focus is retained locally and sent to Clarity only as the final
          drop-off field when a form is abandoned:
          
          SECTION 0 - Basic Information:
          - name, email, phone, preferredLanguage, state, county, city, zipCode
          - interestedProducts (all 6 checkboxes)
          - hasBusiness (yes/no/planning)
          - businessName, businessAddress, businessWebsite, businessType, businessEstablished, numberOfEmployees
          - wantsDetailedQuestionnaire (yes/no)
          
          SECTION: Technical Assistance:
          - businessIndustry
          - businessHelpAspects_marketing
          
          SECTION: Business Operational Tools:
          - businessBanking_businessAccounts
          
          SECTION: Commercial Real Estate:
          - lookingToRentOrBuy_yes
          
          SECTION: Solar and Energy:
          - creditScoreRange_solar
          
          SECTION: Finding Investors:
          - knowsInvestorType_yes
          
          SECTION: Loans and Capital:
          - hasRegisteredEntity_yes, loanAmount, loanTermMonths
          - capitalProductType_term_loan
          
          FINAL CONSENT SECTION:
          - wantsToConnect_yes, wantsFormCopy_yes
          - fileUploadConsent, consentToShare
          
          These tracked fields provide visibility into where users abandon the form.
        -->

        <!-- Section 0 - Basic Information (Multi-page) -->
        @if (!isLoanApplication && currentSection === 0) {
          <div class="form-section">
            <!-- Page 0: What are you looking for? -->
            @if (section0Page === 0) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_PRODUCTS"
                      | translate
                  }}
                </h2>
                <p class="page-question-subtitle">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.SELECT_ALL_THAT_APPLY"
                      | translate
                  }}
                </p>

                <div class="modern-options-grid">
                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="isProductSelected('loansAndCapital')"
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('loansAndCapital')"
                      name="loansAndCapital"
                      (change)="toggleProduct('loansAndCapital')"
                      (focus)="
                        trackFieldInteraction(
                          'interestedProducts_loansAndCapital'
                        )
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.LOANS_AND_CAPITAL"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="isProductSelected('technicalAssistance')"
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('technicalAssistance')"
                      name="technicalAssistance"
                      (change)="toggleProduct('technicalAssistance')"
                      (focus)="
                        trackFieldInteraction(
                          'interestedProducts_technicalAssistance'
                        )
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.TECHNICAL_ASSISTANCE"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="
                      isProductSelected('businessOperationalTools')
                    "
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('businessOperationalTools')"
                      name="businessOperationalTools"
                      (change)="toggleProduct('businessOperationalTools')"
                      (focus)="
                        trackFieldInteraction(
                          'interestedProducts_businessOperationalTools'
                        )
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.BUSINESS_TOOLS"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="isProductSelected('commercialRealEstate')"
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('commercialRealEstate')"
                      name="commercialRealEstate"
                      (change)="toggleProduct('commercialRealEstate')"
                      (focus)="
                        trackFieldInteraction(
                          'interestedProducts_commercialRealEstate'
                        )
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.COMMERCIAL_REAL_ESTATE"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="isProductSelected('solarAndEnergy')"
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('solarAndEnergy')"
                      name="solarAndEnergy"
                      (change)="
                        toggleProduct('solarAndEnergy');
                        onSolarAndEnergyCheckboxChange(
                          isProductSelected('solarAndEnergy')
                        )
                      "
                      (focus)="
                        trackFieldInteraction(
                          'interestedProducts_solarAndEnergy'
                        )
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.SOLAR_AND_ENERGY"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card modern-checkbox-card"
                    [class.selected]="isProductSelected('findingInvestors')"
                  >
                    <input
                      type="checkbox"
                      [checked]="isProductSelected('findingInvestors')"
                      name="findingInvestors"
                      (change)="
                        toggleProduct('findingInvestors');
                        onFindingInvestorsCheckboxChange()
                      "
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.FINDING_INVESTORS"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>
                </div>
              </div>
            }

            <!-- Page 1: Do you have a business? (question only) -->
            @if (section0Page === 1) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.DO_YOU_HAVE_BUSINESS"
                      | translate
                  }}
                </h2>
                <p class="page-question-subtitle">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_STATUS_SUBTITLE"
                      | translate
                  }}
                </p>

                <div class="modern-options-grid single-column">
                  <label
                    class="modern-option-card"
                    [class.selected]="form.hasBusiness === 'yes'"
                    (click)="form.hasBusiness = 'yes'; onHasBusinessChange()"
                    tabindex="0"
                    (keydown.enter)="
                      form.hasBusiness = 'yes'; onHasBusinessChange()
                    "
                  >
                    <input
                      type="radio"
                      [(ngModel)]="form.hasBusiness"
                      name="hasBusiness"
                      value="yes"
                      (focus)="trackFieldInteraction('hasBusiness_yes')"
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                      </div>
                      <div class="option-description">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_YES_DESCRIPTION"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card"
                    [class.selected]="form.hasBusiness === 'no'"
                    (click)="form.hasBusiness = 'no'; onHasBusinessChange()"
                    tabindex="0"
                    (keydown.enter)="
                      form.hasBusiness = 'no'; onHasBusinessChange()
                    "
                  >
                    <input
                      type="radio"
                      [(ngModel)]="form.hasBusiness"
                      name="hasBusiness"
                      value="no"
                      (focus)="trackFieldInteraction('hasBusiness_no')"
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                      </div>
                      <div class="option-description">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_NO_DESCRIPTION"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>

                  <label
                    class="modern-option-card"
                    [class.selected]="form.hasBusiness === 'planning'"
                    (click)="
                      form.hasBusiness = 'planning'; onHasBusinessChange()
                    "
                    tabindex="0"
                    (keydown.enter)="
                      form.hasBusiness = 'planning'; onHasBusinessChange()
                    "
                  >
                    <input
                      type="radio"
                      [(ngModel)]="form.hasBusiness"
                      name="hasBusiness"
                      value="planning"
                      (focus)="trackFieldInteraction('hasBusiness_planning')"
                    />
                    <div class="option-content">
                      <div class="option-title">
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.I_WANT_TO_START_ONE"
                            | translate
                        }}
                      </div>
                      <div class="option-description">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_PLANNING_DESCRIPTION"
                            | translate
                        }}
                      </div>
                    </div>
                    <div class="option-checkmark"></div>
                  </label>
                </div>
              </div>
            }

            <!-- Page 2: Application Summary (What help do you need?) -->
            @if (section0Page === 2) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  @if (form.hasBusiness === "yes") {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.APPLICATION_SUMMARY_BUSINESS"
                        | translate
                    }}
                  } @else {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.APPLICATION_SUMMARY_GENERAL"
                        | translate
                    }}
                  }
                </h2>
                <p class="page-question-subtitle">
                  @if (form.hasBusiness === "yes") {
                    {{
                      "GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_BUSINESS_SUBTITLE"
                        | translate
                    }}
                  } @else {
                    {{
                      "GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_GENERAL_SUBTITLE"
                        | translate
                    }}
                  }
                </p>

                <div class="form-group">
                  <textarea
                    id="applicationSummary"
                    placeholder="{{
                      form.hasBusiness === 'yes'
                        ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_BUSINESS'
                          | translate)
                        : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.APPLICATION_SUMMARY_GENERAL'
                          | translate)
                    }}"
                    [(ngModel)]="form.applicationSummary"
                    name="applicationSummary"
                    rows="6"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('applicationSummary')"
                    style="
                      width: 100%;
                      font-size: 0.93rem;
                      padding: 0.75rem;
                      border: 2px solid #e2e8f0;
                      border-radius: 8px;
                      resize: vertical;
                      min-height: 150px;
                    "
                  ></textarea>
                </div>
              </div>
            }

            <!-- Page 3: Location (state, county, city, zipCode) -->
            @if (section0Page === 3) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  @if (form.hasBusiness === "yes") {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.WHERE_IS_BUSINESS_LOCATED"
                        | translate
                    }}
                  } @else {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.WHERE_ARE_YOU_LOCATED"
                        | translate
                    }}
                  }
                </h2>
                <p class="page-question-subtitle">
                  @if (form.hasBusiness === "yes") {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOCATION_SUBTITLE_BUSINESS"
                        | translate
                    }}
                  } @else {
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOCATION_SUBTITLE_PERSONAL"
                        | translate
                    }}
                  }
                </p>

                @if (form.hasBusiness !== "yes") {
                  <div class="form-group">
                    <label for="businessAddress" class="required">
                      {{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.ADDRESS" | translate
                      }}
                    </label>
                    <input
                      id="businessAddress"
                      [(ngModel)]="form.businessAddress"
                      name="businessAddress"
                      required
                      (ngModelChange)="saveFormData()"
                      (focus)="trackFieldInteraction('businessAddress')"
                    />
                  </div>
                }

                <div class="form-group">
                  <label for="state" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.STATE" | translate
                  }}</label>
                  <app-combobox
                    id="state"
                    name="state"
                    [(ngModel)]="form.state"
                    [required]="true"
                    (ngModelChange)="onStateChange()"
                    (focus)="trackFieldInteraction('state')"
                    [options]="states"
                    labelKey="name"
                    valueKey="name"
                    [placeholder]="
                      'GENERAL_OUTREACH_FORM.OPTIONS.SELECT_STATE' | translate
                    "
                    [autoSort]="true"
                  ></app-combobox>
                </div>

                <div class="form-group">
                  <label for="county" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.COUNTY" | translate
                  }}</label>
                  <app-combobox
                    id="county"
                    name="county"
                    [(ngModel)]="form.county"
                    [required]="true"
                    (ngModelChange)="onCountyChange()"
                    (focus)="trackFieldInteraction('county')"
                    [options]="availableCounties"
                    labelKey="name"
                    valueKey="name"
                    [placeholder]="getCountyPlaceholder()"
                    [disabled]="!form.state || availableCounties.length === 0"
                    [autoSort]="true"
                  ></app-combobox>
                </div>

                <div class="form-group">
                  <label for="city" class="required">
                    {{ "GENERAL_OUTREACH_FORM.FORM_FIELDS.CITY" | translate }}
                  </label>
                  <app-combobox
                    id="city"
                    name="city"
                    [(ngModel)]="form.city"
                    [required]="true"
                    (ngModelChange)="onCityChange()"
                    (focus)="trackFieldInteraction('city')"
                    [options]="availableCities"
                    labelKey="name"
                    valueKey="name"
                    [labelFormatter]="formatCityItem"
                    [placeholder]="getCityPlaceholder()"
                    [disabled]="!form.state || availableCities.length === 0"
                    [autoSort]="true"
                  ></app-combobox>
                </div>

                <div class="form-group">
                  <label for="zipCode" class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.ZIP_CODE" | translate
                    }}
                  </label>
                  <app-combobox
                    id="zipCode"
                    name="zipCode"
                    [(ngModel)]="form.zipCode"
                    [required]="true"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('zipCode')"
                    [options]="availableZipCodes"
                    labelKey="code"
                    valueKey="code"
                    [placeholder]="getZipPlaceholder()"
                    [disabled]="!form.city || availableZipCodes.length === 0"
                    [autoSort]="true"
                  ></app-combobox>
                </div>
              </div>
            }

            <!-- Page 4: Business Details (only if hasBusiness === 'yes') -->
            @if (section0Page === 4 && form.hasBusiness === "yes") {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_DETAILS_HEADING"
                      | translate
                  }}
                </h2>
                <p class="page-question-subtitle">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_DETAILS_SUBTITLE"
                      | translate
                  }}
                </p>

                <div class="form-group">
                  <label for="businessName" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_NAME"
                      | translate
                  }}</label>
                  <input
                    id="businessName"
                    [(ngModel)]="form.businessName"
                    name="businessName"
                    required
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('businessName')"
                  />
                </div>

                <div class="form-group">
                  <label for="businessAddress" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ADDRESS"
                      | translate
                  }}</label>
                  <input
                    id="businessAddress"
                    [(ngModel)]="form.businessAddress"
                    name="businessAddress"
                    required
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('businessAddress')"
                  />
                </div>

                <div class="form-group">
                  <label for="displayBusinessAddress">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ADDRESS_LINE2"
                      | translate
                  }}</label>
                  <input
                    id="displayBusinessAddress"
                    [value]="businessAddressLine2"
                    readonly
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label for="businessWebsite">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_WEBSITE"
                      | translate
                  }}</label>
                  <input
                    id="businessWebsite"
                    [(ngModel)]="form.businessWebsite"
                    name="businessWebsite"
                    [placeholder]="
                      'GENERAL_OUTREACH_FORM.PLACEHOLDERS.WEBSITE' | translate
                    "
                    [class.invalid]="form.businessWebsite && !isWebsiteValid()"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('businessWebsite')"
                  />
                  @if (form.businessWebsite && !isWebsiteValid()) {
                    <span class="error-message">{{
                      "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_WEBSITE"
                        | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="businessType" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_TYPE"
                      | translate
                  }}</label>
                  <select
                    id="businessType"
                    [(ngModel)]="form.businessType"
                    name="businessType"
                    required
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('businessType')"
                  >
                    <option value="">
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_BUSINESS_TYPE"
                          | translate
                      }}
                    </option>
                    @for (option of businessTypeOptions; track option.value) {
                      <option [value]="option.value">
                        {{ option.labelKey | translate }}
                      </option>
                    }
                  </select>
                </div>

                <div class="form-group">
                  <label for="businessEstablished" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ESTABLISHED"
                      | translate
                  }}</label>
                  <input
                    id="businessEstablished"
                    type="text"
                    [(ngModel)]="form.businessEstablished"
                    name="businessEstablished"
                    [placeholder]="
                      'GENERAL_OUTREACH_FORM.PLACEHOLDERS.BUSINESS_ESTABLISHED'
                        | translate
                    "
                    required
                    (ngModelChange)="onBusinessEstablishedChange()"
                    (focus)="trackFieldInteraction('businessEstablished')"
                  />
                  @if (
                    form.businessEstablished && !isBusinessEstablishedValid()
                  ) {
                    <span class="error-message">{{
                      "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_BUSINESS_ESTABLISHED"
                        | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="numberOfEmployees" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.NUMBER_OF_FTE"
                      | translate
                  }}</label>
                  <input
                    id="numberOfEmployees"
                    type="number"
                    step="1"
                    [(ngModel)]="form.numberOfEmployees"
                    name="numberOfEmployees"
                    required
                    min="0"
                    [class.invalid]="!isNumberOfEmployeesValid()"
                    (ngModelChange)="onNumberOfEmployeesChange($event)"
                    (keydown)="restrictIntegerInput($event)"
                    (focus)="trackFieldInteraction('numberOfEmployees')"
                  />
                  @if (!isNumberOfEmployeesValid()) {
                    <span class="error-message">{{
                      getFinancialFieldError("numberOfEmployees") | translate
                    }}</span>
                  }
                </div>
              </div>
            }

            <!-- Page 5: Language and Military Veterans -->
            @if (section0Page === 5) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.MORE_DETAILS_HEADING"
                      | translate
                  }}
                </h2>
                <p class="page-question-subtitle">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.MORE_DETAILS_SUBTITLE"
                      | translate
                  }}
                </p>

                <div class="form-group">
                  <label for="preferredLanguage" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PREFERRED_LANGUAGE"
                      | translate
                  }}</label>
                  <select
                    id="preferredLanguage"
                    [(ngModel)]="form.preferredLanguage"
                    name="preferredLanguage"
                    required
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('preferredLanguage')"
                  >
                    <option value="">
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_LANGUAGE"
                          | translate
                      }}
                    </option>
                    <option value="English">
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.ENGLISH" | translate }}
                    </option>
                    <option value="Spanish">
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.SPANISH" | translate }}
                    </option>
                  </select>
                </div>

                <!-- Military Veteran Question -->
                <fieldset class="modern-fieldset">
                  <legend>
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.IS_MILITARY_VETERAN"
                        | translate
                    }}
                  </legend>
                  <div class="modern-options-grid two-columns">
                    <label
                      class="modern-option-card"
                      [class.selected]="form.isMilitaryVeteran === true"
                      (click)="form.isMilitaryVeteran = true; saveFormData()"
                      tabindex="0"
                      (keydown.enter)="
                        form.isMilitaryVeteran = true; saveFormData()
                      "
                      (keydown.space)="
                        form.isMilitaryVeteran = true; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.isMilitaryVeteran"
                        name="isMilitaryVeteran"
                        [value]="true"
                        (focus)="trackFieldInteraction('isMilitaryVeteran_yes')"
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>

                    <label
                      class="modern-option-card"
                      [class.selected]="form.isMilitaryVeteran === false"
                      (click)="form.isMilitaryVeteran = false; saveFormData()"
                      tabindex="0"
                      (keydown.enter)="
                        form.isMilitaryVeteran = false; saveFormData()
                      "
                      (keydown.space)="
                        form.isMilitaryVeteran = false; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.isMilitaryVeteran"
                        name="isMilitaryVeteran"
                        [value]="false"
                        (focus)="trackFieldInteraction('isMilitaryVeteran_no')"
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>
                  </div>
                </fieldset>

                <!-- Veteran Spouse Question -->
                <fieldset class="modern-fieldset">
                  <legend>
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.IS_VETERAN_SPOUSE"
                        | translate
                    }}
                  </legend>
                  <div class="modern-options-grid two-columns">
                    <label
                      class="modern-option-card"
                      [class.selected]="form.isVeteranSpouse === true"
                      (click)="form.isVeteranSpouse = true; saveFormData()"
                      tabindex="0"
                      (keydown.enter)="
                        form.isVeteranSpouse = true; saveFormData()
                      "
                      (keydown.space)="
                        form.isVeteranSpouse = true; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.isVeteranSpouse"
                        name="isVeteranSpouse"
                        [value]="true"
                        (focus)="trackFieldInteraction('isVeteranSpouse_yes')"
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>

                    <label
                      class="modern-option-card"
                      [class.selected]="form.isVeteranSpouse === false"
                      (click)="form.isVeteranSpouse = false; saveFormData()"
                      tabindex="0"
                      (keydown.enter)="
                        form.isVeteranSpouse = false; saveFormData()
                      "
                      (keydown.space)="
                        form.isVeteranSpouse = false; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.isVeteranSpouse"
                        name="isVeteranSpouse"
                        [value]="false"
                        (focus)="trackFieldInteraction('isVeteranSpouse_no')"
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>
                  </div>
                </fieldset>
              </div>
            }

            <!-- Page 6: Name, email, phone, detailed questionnaire -->
            @if (section0Page === 6) {
              <div class="modern-page-container">
                <h2 class="page-question-heading">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONTACT_HEADING"
                      | translate
                  }}
                </h2>
                <p class="page-question-subtitle">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONTACT_SUBTITLE"
                      | translate
                  }}
                </p>

                <div class="form-group">
                  <label for="name" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.NAME" | translate
                  }}</label>
                  <input
                    id="name"
                    [(ngModel)]="form.name"
                    name="name"
                    required
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('name')"
                  />
                </div>

                <div class="form-group">
                  <label for="email" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.EMAIL" | translate
                  }}</label>
                  <input
                    id="email"
                    [(ngModel)]="form.email"
                    name="email"
                    required
                    [class.invalid]="form.email && !isEmailValid()"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('email')"
                  />
                  @if (form.email && !isEmailValid()) {
                    <span class="error-message">{{
                      "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_EMAIL"
                        | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="phone">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PHONE" | translate
                  }}</label>
                  <input
                    id="phone"
                    [(ngModel)]="form.phone"
                    name="phone"
                    [class.invalid]="!isPhoneValid()"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('phone')"
                  />
                  @if (form.phone && !isPhoneValid()) {
                    <span class="error-message">{{
                      "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PHONE"
                        | translate
                    }}</span>
                  }
                </div>

                <!-- Chamber of Commerce Question -->
                <fieldset class="modern-fieldset">
                  <legend>
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_IN_CHAMBER_OR_BUSINESS_NETWORKING"
                        | translate
                    }}
                  </legend>
                  <div class="modern-options-grid two-columns">
                    <label
                      class="modern-option-card"
                      [class.selected]="form.wantsToConnect === true"
                      (click)="onChamberNetworkingYes()"
                      tabindex="0"
                      (keydown.enter)="onChamberNetworkingYes()"
                      (keydown.space)="onChamberNetworkingYes()"
                    >
                      <input
                        type="radio"
                        [checked]="form.wantsToConnect === true"
                        name="interestedInChamberOrBusinessNetworking"
                        [value]="true"
                        (focus)="
                          trackFieldInteraction(
                            'interestedInChamberOrBusinessNetworking_yes'
                          )
                        "
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>

                    <label
                      class="modern-option-card"
                      [class.selected]="form.wantsToConnect === false"
                      (click)="onChamberNetworkingNo()"
                      tabindex="0"
                      (keydown.enter)="onChamberNetworkingNo()"
                      (keydown.space)="onChamberNetworkingNo()"
                    >
                      <input
                        type="radio"
                        [checked]="form.wantsToConnect === false"
                        name="interestedInChamberOrBusinessNetworking"
                        [value]="false"
                        (focus)="
                          trackFieldInteraction(
                            'interestedInChamberOrBusinessNetworking_no'
                          )
                        "
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>
                  </div>
                </fieldset>

                <!-- Detailed Questionnaire Question -->
                <fieldset class="modern-fieldset">
                  <legend>
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.DETAILED_QUESTIONNAIRE"
                        | translate
                    }}
                  </legend>
                  <div class="modern-options-grid two-columns">
                    <label
                      class="modern-option-card"
                      [class.selected]="
                        form.wantsDetailedQuestionnaire === true
                      "
                      (click)="
                        form.wantsDetailedQuestionnaire = true; saveFormData()
                      "
                      tabindex="0"
                      (keydown.enter)="
                        form.wantsDetailedQuestionnaire = true; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.wantsDetailedQuestionnaire"
                        name="wantsDetailedQuestionnaire"
                        [value]="true"
                        (focus)="
                          trackFieldInteraction(
                            'wantsDetailedQuestionnaire_yes'
                          )
                        "
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </div>
                        <div class="option-description">
                          {{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.DETAILED_QUESTIONNAIRE_YES_DESCRIPTION"
                              | translate
                          }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>

                    <label
                      class="modern-option-card"
                      [class.selected]="
                        form.wantsDetailedQuestionnaire === false
                      "
                      (click)="
                        form.wantsDetailedQuestionnaire = false; saveFormData()
                      "
                      tabindex="0"
                      (keydown.enter)="
                        form.wantsDetailedQuestionnaire = false; saveFormData()
                      "
                    >
                      <input
                        type="radio"
                        [(ngModel)]="form.wantsDetailedQuestionnaire"
                        name="wantsDetailedQuestionnaire"
                        [value]="false"
                        (focus)="
                          trackFieldInteraction('wantsDetailedQuestionnaire_no')
                        "
                      />
                      <div class="option-content">
                        <div class="option-title">
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </div>
                        <div class="option-description">
                          {{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.DETAILED_QUESTIONNAIRE_NO_DESCRIPTION"
                              | translate
                          }}
                        </div>
                      </div>
                      <div class="option-checkmark"></div>
                    </label>
                  </div>
                </fieldset>

                <!-- Show Final Consent Section if user answered "No" to detailed questionnaire -->
                @if (form.wantsDetailedQuestionnaire === false) {
                  <div style="margin-top: 10px">
                    <!-- File Upload Section -->
                    <div class="form-group file-upload-section">
                      <div class="section-label">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.UPLOAD_DOCUMENTS"
                            | translate
                        }}
                        <span class="optional-label"
                          >({{
                            "GENERAL_OUTREACH_FORM.LABELS.OPTIONAL" | translate
                          }})</span
                        >
                      </div>
                      <p class="file-upload-description">
                        {{
                          "GENERAL_OUTREACH_FORM.NOTES.FILE_UPLOAD_DESCRIPTION"
                            | translate
                        }}
                      </p>

                      <div class="file-upload-container">
                        <input
                          type="file"
                          #fileInput
                          (change)="onFileSelect($event)"
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                          [disabled]="selectedFiles.length >= 3"
                          multiple
                          style="display: none"
                        />
                        <button
                          type="button"
                          class="file-select-button"
                          (click)="fileInput.click()"
                          [disabled]="selectedFiles.length >= 3"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 4V16M4 10H16"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                          {{
                            "GENERAL_OUTREACH_FORM.BUTTONS.SELECT_FILE"
                              | translate
                          }}
                        </button>
                        <span class="file-limit-text">
                          {{ selectedFiles.length }}/3
                          {{
                            "GENERAL_OUTREACH_FORM.LABELS.FILES_SELECTED"
                              | translate
                          }}
                        </span>
                      </div>

                      @if (fileUploadError) {
                        <p class="error-message" style="margin-top: 10px">
                          {{ fileUploadError }}
                        </p>
                      }

                      <!-- Display selected files -->
                      @if (selectedFiles.length > 0) {
                        <div class="selected-files-list">
                          @for (file of selectedFiles; track file.name) {
                            <div class="file-item">
                              <div class="file-info">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="file-icon"
                                >
                                  <path
                                    d="M11 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V8M11 2L17 8M11 2V8H17"
                                    stroke="#334ea5"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                <div class="file-details">
                                  <span class="file-name">{{ file.name }}</span>
                                  <span class="file-size">{{
                                    formatFileSize(file.size)
                                  }}</span>
                                </div>
                              </div>
                              <button
                                type="button"
                                class="remove-file-button"
                                (click)="removeFile(file.name)"
                                [attr.aria-label]="'Remove ' + file.name"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 4L4 12M4 4L12 12"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                </svg>
                              </button>
                            </div>
                          }
                        </div>

                        <!-- File Upload Consent Checkbox -->
                        <div class="checkbox-group" style="margin-top: 1rem">
                          <label style="margin-bottom: 0px">
                            <input
                              type="checkbox"
                              [(ngModel)]="fileUploadConsent"
                              name="fileUploadConsent"
                              (change)="saveFormData()"
                            />
                            <span class="required">
                              {{
                                "GENERAL_OUTREACH_FORM.LABELS.FILE_CONSENT"
                                  | translate
                              }}
                            </span>
                          </label>
                        </div>

                        <!-- Terms of Use Checkbox -->
                        <div class="checkbox-group">
                          <label>
                            <input
                              type="checkbox"
                              [(ngModel)]="termsOfUseConsent"
                              name="termsOfUseConsent"
                              (change)="saveFormData()"
                            />
                            <span class="required">
                              {{
                                "GENERAL_OUTREACH_FORM.LABELS.AGREE_TERMS_OF_USE"
                                  | translate
                              }}
                              <a
                                href="/terms-of-use"
                                target="_blank"
                                (click)="$event.stopPropagation()"
                                >{{
                                  "GENERAL_OUTREACH_FORM.LABELS.TERMS_LINK"
                                    | translate
                                }}</a
                              >.
                            </span>
                          </label>
                        </div>
                      }
                    </div>

                    <fieldset class="form-group">
                      <legend class="required">
                        {{
                          "GENERAL_OUTREACH_FORM.SECTION_TITLES.CONSENT_REVIEW"
                            | translate
                        }}
                      </legend>
                      <div class="checkbox-group">
                        <label [class.disabled]="form.optOutCommunications">
                          <input
                            type="checkbox"
                            [(ngModel)]="form.consentToShare"
                            name="consentToShare"
                            [disabled]="form.optOutCommunications"
                            (ngModelChange)="
                              saveFormData(); onConsentChange('consentToShare')
                            "
                          />
                          <span>{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONSENT_TO_SHARE"
                              | translate
                          }}</span>
                        </label>

                        <label [class.disabled]="form.consentToShare">
                          <input
                            type="checkbox"
                            [(ngModel)]="form.optOutCommunications"
                            name="optOutCommunications"
                            [disabled]="form.consentToShare"
                            (ngModelChange)="
                              saveFormData();
                              onConsentChange('optOutCommunications')
                            "
                          />
                          <span>{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.OPT_OUT_COMMUNICATIONS"
                              | translate
                          }}</span>
                        </label>
                      </div>
                    </fieldset>

                    <!-- Show submission error if any -->
                    @if (submitError) {
                      <div
                        class="error-message-container"
                        style="margin-top: 15px"
                      >
                        <p class="error-message">{{ submitError }}</p>
                        @if (submitFieldErrors.length > 0) {
                          <ul class="error-list">
                            @for (error of submitFieldErrors; track error) {
                              <li class="error-message">{{ error }}</li>
                            }
                          </ul>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <!-- Navigation buttons for all section 0 pages -->
            <div class="form-actions">
              @if (section0Page > 0) {
                <button type="button" class="back-button" (click)="onBack()">
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.BACK" | translate }}
                </button>
              }

              <!-- Show Submit button only on last page if user answered "No" to detailed questionnaire -->
              @if (
                section0Page === 6 && form.wantsDetailedQuestionnaire === false
              ) {
                <button
                  type="button"
                  (click)="submitForm()"
                  [disabled]="!isFormReadyToSubmit()"
                >
                  @if (isSubmitting) {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMITTING" | translate }}
                  } @else {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT" | translate }}
                  }
                </button>
              }

              <!-- Show Next/Continue button for other cases -->
              @if (
                section0Page < 6 ||
                (section0Page === 6 &&
                  form.wantsDetailedQuestionnaire !== false)
              ) {
                <button
                  type="button"
                  (click)="onNextPage()"
                  [disabled]="!isBasicSectionValid()"
                >
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.NEXT" | translate }}
                </button>
              }
            </div>
          </div>
        }
        <!-- Section 1+ - Business Product Sections (Dynamic based on selected products) OR Loan Application -->
        @if (
          (currentSection >= 1 && getCurrentProductSection()) ||
          isLoanApplication
        ) {
          <div class="form-section">
            @if (getCurrentProductSection() === "technicalAssistance") {
              <h3>
                {{
                  "GENERAL_OUTREACH_FORM.INTERESTED_PRODUCTS.TECHNICAL_ASSISTANCE"
                    | translate
                }}
              </h3>

              <!-- Show these questions only if user has a business (hasBusiness === 'yes') -->
              @if (form.hasBusiness === "yes") {
                <div class="form-group">
                  <label for="businessIndustry" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_INDUSTRY"
                      | translate
                  }}</label>
                  <select
                    id="businessIndustry"
                    [(ngModel)]="form.businessIndustry"
                    name="businessIndustry"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('businessIndustry')"
                    required
                  >
                    <option value="">
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_INDUSTRY"
                          | translate
                      }}
                    </option>
                    <option value="1111">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.AGRICULTURE"
                          | translate
                      }}
                    </option>
                    <option value="2361">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.CONSTRUCTION"
                          | translate
                      }}
                    </option>
                    <option value="3111">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.MANUFACTURING"
                          | translate
                      }}
                    </option>
                    <option value="4234">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.WHOLESALE_TRADE"
                          | translate
                      }}
                    </option>
                    <option value="4451">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.RETAIL_TRADE"
                          | translate
                      }}
                    </option>
                    <option value="4841">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.TRANSPORTATION"
                          | translate
                      }}
                    </option>
                    <option value="4931">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.WAREHOUSING"
                          | translate
                      }}
                    </option>
                    <option value="5112">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.SOFTWARE_TECH"
                          | translate
                      }}
                    </option>
                    <option value="5415">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.IT_SERVICES"
                          | translate
                      }}
                    </option>
                    <option value="5221">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.BANKING_FINANCIAL"
                          | translate
                      }}
                    </option>
                    <option value="5241">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.INSURANCE" | translate
                      }}
                    </option>
                    <option value="5311">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.REAL_ESTATE"
                          | translate
                      }}
                    </option>
                    <option value="5416">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.PROFESSIONAL_CONSULTING"
                          | translate
                      }}
                    </option>
                    <option value="6211">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.HEALTHCARE"
                          | translate
                      }}
                    </option>
                    <option value="7225">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.RESTAURANTS"
                          | translate
                      }}
                    </option>
                    <option value="7211">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.HOTELS" | translate
                      }}
                    </option>
                    <option value="8111">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.AUTOMOTIVE"
                          | translate
                      }}
                    </option>
                    <option value="8121">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.PERSONAL_SERVICES"
                          | translate
                      }}
                    </option>
                    <option value="9281">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.GOVERNMENT"
                          | translate
                      }}
                    </option>
                    <option value="6111">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.EDUCATIONAL_SERVICES"
                          | translate
                      }}
                    </option>
                    <option value="2121">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.MINING" | translate
                      }}
                    </option>
                    <option value="2211">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.UTILITIES" | translate
                      }}
                    </option>
                    <option value="5621">
                      {{
                        "GENERAL_OUTREACH_FORM.INDUSTRIES.WASTE_MANAGEMENT"
                          | translate
                      }}
                    </option>
                    <option value="0000">
                      {{ "GENERAL_OUTREACH_FORM.INDUSTRIES.OTHER" | translate }}
                    </option>
                  </select>
                </div>

                <fieldset class="form-group">
                  <legend class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_HELP_ASPECTS"
                        | translate
                    }}
                  </legend>
                  <div class="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isBusinessHelpAspectSelected('marketing')"
                        (change)="toggleBusinessHelpAspect('marketing')"
                        (focus)="
                          trackFieldInteraction('businessHelpAspects_marketing')
                        "
                        name="marketing"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.MARKETING"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('financesAccounting')
                        "
                        (change)="
                          toggleBusinessHelpAspect('financesAccounting')
                        "
                        name="financesAccounting"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.FINANCES_ACCOUNTING"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isBusinessHelpAspectSelected('strategy')"
                        (change)="toggleBusinessHelpAspect('strategy')"
                        name="strategy"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.STRATEGY"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('legalAssistance')
                        "
                        (change)="toggleBusinessHelpAspect('legalAssistance')"
                        name="legalAssistance"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.LEGAL_ASSISTANCE"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('businessSuccession')
                        "
                        (change)="
                          toggleBusinessHelpAspect('businessSuccession')
                        "
                        name="businessSuccession"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.BUSINESS_SUCCESSION"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('applyingForGrant')
                        "
                        (change)="toggleBusinessHelpAspect('applyingForGrant')"
                        name="applyingForGrant"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.APPLYING_FOR_GRANT"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isBusinessHelpAspectSelected('taxStructure')"
                        (change)="toggleBusinessHelpAspect('taxStructure')"
                        name="taxStructure"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.TAX_STRUCTURE"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('siteSelection')
                        "
                        (change)="toggleBusinessHelpAspect('siteSelection')"
                        name="siteSelection"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.SITE_SELECTION"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('humanResources')
                        "
                        (change)="toggleBusinessHelpAspect('humanResources')"
                        name="humanResources"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.HUMAN_RESOURCES"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('operationalPlanning')
                        "
                        (change)="
                          toggleBusinessHelpAspect('operationalPlanning')
                        "
                        name="operationalPlanning"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.OPERATIONAL_PLANNING"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('applyingForLoan')
                        "
                        (change)="toggleBusinessHelpAspect('applyingForLoan')"
                        name="applyingForLoan"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.APPLYING_FOR_LOAN"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('bankingAccounts')
                        "
                        (change)="toggleBusinessHelpAspect('bankingAccounts')"
                        name="bankingAccounts"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.BANKING_ACCOUNTS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isBusinessHelpAspectSelected('technology')"
                        (change)="toggleBusinessHelpAspect('technology')"
                        name="technology"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.TECHNOLOGY"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('itInfrastructure')
                        "
                        (change)="toggleBusinessHelpAspect('itInfrastructure')"
                        name="itInfrastructure"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.IT_INFRASTRUCTURE"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('investmentReadiness')
                        "
                        (change)="
                          toggleBusinessHelpAspect('investmentReadiness')
                        "
                        name="investmentReadiness"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.INVESTMENT_READINESS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('governmentContracting')
                        "
                        (change)="
                          toggleBusinessHelpAspect('governmentContracting')
                        "
                        name="governmentContracting"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.GOVERNMENT_CONTRACTING"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          isBusinessHelpAspectSelected('manufacturingSupport')
                        "
                        (change)="
                          toggleBusinessHelpAspect('manufacturingSupport')
                        "
                        name="manufacturingSupport"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.BUSINESS_HELP.MANUFACTURING_SUPPORT"
                          | translate
                      }}
                    </label>
                  </div>
                </fieldset>

                <!-- Business Succession Planning Questions -->
                @if (isBusinessHelpAspectSelected("businessSuccession")) {
                  <div class="form-group">
                    <label for="interestedInSellingBusiness" class="required">{{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_IN_SELLING"
                        | translate
                    }}</label>
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInSellingBusiness"
                          name="interestedInSellingBusiness"
                          value="yes"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInSellingBusiness"
                          name="interestedInSellingBusiness"
                          value="no"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInSellingBusiness"
                          name="interestedInSellingBusiness"
                          value="make_plan"
                          (ngModelChange)="saveFormData()"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.MAKE_A_PLAN"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="interestedInEmployeeStrategies"
                      class="required"
                      >{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_IN_EMPLOYEE_STRATEGIES"
                          | translate
                      }}</label
                    >
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInEmployeeStrategies"
                          name="interestedInEmployeeStrategies"
                          value="yes"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInEmployeeStrategies"
                          name="interestedInEmployeeStrategies"
                          value="no"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInEmployeeStrategies"
                          name="interestedInEmployeeStrategies"
                          value="learn_more"
                          (ngModelChange)="saveFormData()"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.OPTIONS.LEARN_MORE" | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="interestedInSuccessionPlanning"
                      class="required"
                      >{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.INTERESTED_IN_SUCCESSION_PLANNING"
                          | translate
                      }}</label
                    >
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInSuccessionPlanning"
                          name="interestedInSuccessionPlanning"
                          [value]="true"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.interestedInSuccessionPlanning"
                          name="interestedInSuccessionPlanning"
                          [value]="false"
                          (ngModelChange)="saveFormData()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                      </label>
                    </div>
                  </div>
                }
              }

              @if (form.hasBusiness === "planning") {
                <fieldset class="form-group">
                  <legend class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.WANTS_STARTUP_ASSISTANCE"
                        | translate
                    }}
                  </legend>
                  <div class="radio-group">
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.wantsStartupAssistance"
                        [value]="true"
                        name="wantsStartupAssistance"
                        (ngModelChange)="saveFormData()"
                      />
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.wantsStartupAssistance"
                        [value]="false"
                        name="wantsStartupAssistance"
                        (ngModelChange)="saveFormData()"
                      />
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                    </label>
                  </div>
                </fieldset>
              }

              @if (form.hasBusiness === "no") {
                <fieldset class="form-group">
                  <legend class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.STARTUP_HELP_AREAS"
                        | translate
                    }}
                  </legend>
                  <div class="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          form.startupHelpAreas.includes('business_plan')
                        "
                        (change)="
                          toggleArrayValue(
                            form.startupHelpAreas,
                            'business_plan',
                            $event
                          )
                        "
                        name="startupBusinessPlan"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.STARTUP_HELP.BUSINESS_PLAN"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          form.startupHelpAreas.includes('financial_forecast')
                        "
                        (change)="
                          toggleArrayValue(
                            form.startupHelpAreas,
                            'financial_forecast',
                            $event
                          )
                        "
                        name="startupFinancialForecast"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.STARTUP_HELP.FINANCIAL_FORECAST"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          form.startupHelpAreas.includes('business_structures')
                        "
                        (change)="
                          toggleArrayValue(
                            form.startupHelpAreas,
                            'business_structures',
                            $event
                          )
                        "
                        name="startupBusinessStructures"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.STARTUP_HELP.BUSINESS_STRUCTURES"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="
                          form.startupHelpAreas.includes('available_resources')
                        "
                        (change)="
                          toggleArrayValue(
                            form.startupHelpAreas,
                            'available_resources',
                            $event
                          )
                        "
                        name="startupAvailableResources"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.STARTUP_HELP.AVAILABLE_RESOURCES"
                          | translate
                      }}
                    </label>
                  </div>
                </fieldset>
              }

              <!-- Common questions for all users who selected Technical Assistance -->
              <div class="form-group">
                <label for="workedWithSupportOrg" class="required">{{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.WORKED_WITH_SUPPORT_ORG"
                    | translate
                }}</label>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.workedWithSupportOrg"
                      name="workedWithSupportOrg"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.workedWithSupportOrg"
                      name="workedWithSupportOrg"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label for="willingToPayForAssistance" class="required">{{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.WILLING_TO_PAY_FOR_ASSISTANCE"
                    | translate
                }}</label>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.willingToPayForAssistance"
                      name="willingToPayForAssistance"
                      value="yes"
                      (ngModelChange)="saveFormData()"
                    />
                    {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.willingToPayForAssistance"
                      name="willingToPayForAssistance"
                      value="not_at_this_time"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.OPTIONS.NOT_AT_THIS_TIME"
                        | translate
                    }}
                  </label>
                </div>
              </div>
            }

            @if (getCurrentProductSection() === "businessOperationalTools") {
              <h3>
                {{
                  "GENERAL_OUTREACH_FORM.INTERESTED_PRODUCTS.BUSINESS_TOOLS"
                    | translate
                }}
              </h3>
              <fieldset class="form-group">
                <legend>
                  {{ "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.TITLE" | translate }}
                </legend>
                <div class="checkbox-group">
                  <!-- Business Banking Section -->
                  <div>
                    <span style="font-weight: 600">{{
                      "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.BUSINESS_BANKING"
                        | translate
                    }}</span>
                    <div style="margin-left: 2rem">
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessBankingSelected('businessAccounts')
                          "
                          (change)="toggleBusinessBanking('businessAccounts')"
                          (focus)="
                            trackFieldInteraction(
                              'businessBanking_businessAccounts'
                            )
                          "
                          name="businessAccounts"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.CHECKING_SAVINGS"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="isBusinessBankingSelected('payrollAndHr')"
                          (change)="toggleBusinessBanking('payrollAndHr')"
                          name="payrollAndHr"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.HR_PROCESSING"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="isBusinessBankingSelected('linesOfCredit')"
                          (change)="toggleBusinessBanking('linesOfCredit')"
                          name="linesOfCredit"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.LINES_OF_CREDIT"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessBankingSelected('manageCashFlow')
                          "
                          (change)="toggleBusinessBanking('manageCashFlow')"
                          name="manageCashFlow"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.TREASURY_SERVICES"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessBankingSelected('financialStrategy')
                          "
                          (change)="toggleBusinessBanking('financialStrategy')"
                          name="financialStrategy"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.ADVISING_SERVICES"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- Marketing Help Section -->
                  <div>
                    <span style="font-weight: 600">{{
                      "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.MARKETING_TOOLS"
                        | translate
                    }}</span>
                    <div style="margin-left: 2rem">
                      <label>
                        <input
                          type="checkbox"
                          [checked]="isMarketingHelpSelected('websiteDesign')"
                          (change)="toggleMarketingHelp('websiteDesign')"
                          name="websiteDesign"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.WEBSITE_DESIGN"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isMarketingHelpSelected('physicalMarketing')
                          "
                          (change)="toggleMarketingHelp('physicalMarketing')"
                          name="physicalMarketing"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.PHYSICAL_MARKETING"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isMarketingHelpSelected('marketingStrategy')
                          "
                          (change)="toggleMarketingHelp('marketingStrategy')"
                          name="marketingStrategy"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.MARKETING_CONSULTING"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- Tech Support Section -->
                  <div>
                    <span style="font-weight: 600">{{
                      "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.TECHNOLOGY_SERVICES"
                        | translate
                    }}</span>
                    <div style="margin-left: 2rem">
                      <label>
                        <input
                          type="checkbox"
                          [checked]="isTechSupportSelected('itSupport')"
                          (change)="toggleTechSupport('itSupport')"
                          name="itSupport"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.IT_SUPPORT"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isTechSupportSelected('physicalInfrastructure')
                          "
                          (change)="toggleTechSupport('physicalInfrastructure')"
                          name="physicalInfrastructure"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.PHYSICAL_INFRASTRUCTURE"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- Business Insurance Section -->
                  <div>
                    <span style="font-weight: 600">{{
                      "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.INSURANCE_SERVICES"
                        | translate
                    }}</span>
                    <div style="margin-left: 2rem">
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('generalInsurance')
                          "
                          (change)="toggleBusinessInsurance('generalInsurance')"
                          name="generalInsurance"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.BUSINESS_INSURANCE"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('disasterInsurance')
                          "
                          (change)="
                            toggleBusinessInsurance('disasterInsurance')
                          "
                          name="disasterInsurance"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.DISASTER_INSURANCE"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('buildingInsurance')
                          "
                          (change)="
                            toggleBusinessInsurance('buildingInsurance')
                          "
                          name="buildingInsurance"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.LAND_BUILDING_INSURANCE"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('lawsuitProtection')
                          "
                          (change)="
                            toggleBusinessInsurance('lawsuitProtection')
                          "
                          name="lawsuitProtection"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.LIABILITY_INSURANCE"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('keyTeamInsurance')
                          "
                          (change)="toggleBusinessInsurance('keyTeamInsurance')"
                          name="keyTeamInsurance"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.KEY_EXECUTIVE_INSURANCE"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          [checked]="
                            isBusinessInsuranceSelected('directorsCoverage')
                          "
                          (change)="
                            toggleBusinessInsurance('directorsCoverage')
                          "
                          name="directorsCoverage"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.DIRECTORS_OFFICER_INSURANCE"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>

                  <!-- New Technology Section -->
                  <div>
                    <span style="font-weight: 600">{{
                      "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.NEW_TECHNOLOGY"
                        | translate
                    }}</span>
                    <div style="margin-left: 2rem">
                      <label>
                        <input
                          type="checkbox"
                          [checked]="isNewTechnologySelected('newDigitalTools')"
                          (change)="toggleNewTechnology('newDigitalTools')"
                          name="newDigitalTools"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.BUSINESS_TOOLS.NEW_TECHNOLOGY_ADOPTION"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            }

            @if (getCurrentProductSection() === "commercialRealEstate") {
              <h3>
                {{
                  "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.SECTION_TITLE"
                    | translate
                }}
              </h3>
              <div class="form-group">
                <!-- Question 1: Looking to rent or buy -->
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.LOOKING_TO_RENT_OR_BUY"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.lookingToRentOrBuy"
                      name="lookingToRentOrBuy"
                      value="yes"
                      (ngModelChange)="saveFormData()"
                      (focus)="trackFieldInteraction('lookingToRentOrBuy_yes')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.YES"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.lookingToRentOrBuy"
                      name="lookingToRentOrBuy"
                      value="no"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NO"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.lookingToRentOrBuy"
                      name="lookingToRentOrBuy"
                      value="unsure"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.UNSURE"
                        | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <!-- Question 2: Looking to upgrade facility -->
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.LOOKING_TO_UPGRADE"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [ngModel]="form.lookingToUpgradeFacility"
                      (ngModelChange)="onLookingToUpgradeChange($event)"
                      name="lookingToUpgradeFacility"
                      [value]="true"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.YES"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [ngModel]="form.lookingToUpgradeFacility"
                      (ngModelChange)="onLookingToUpgradeChange($event)"
                      name="lookingToUpgradeFacility"
                      [value]="false"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NO"
                        | translate
                    }}
                  </label>
                </div>
              </div>

              <!-- Question 3: Do you own your facility (only if lookingToUpgradeFacility is true) -->
              @if (form.lookingToUpgradeFacility === true) {
                <div class="form-group" style="margin-left: 2rem">
                  <span class="required">{{
                    "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.OWN_FACILITY"
                      | translate
                  }}</span>
                  <div class="radio-group">
                    <label>
                      <input
                        type="radio"
                        [ngModel]="form.ownFacility"
                        (ngModelChange)="onOwnFacilityChange($event)"
                        name="ownFacility"
                        [value]="true"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.YES"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [ngModel]="form.ownFacility"
                        (ngModelChange)="onOwnFacilityChange($event)"
                        name="ownFacility"
                        [value]="false"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NO"
                          | translate
                      }}
                    </label>
                  </div>
                </div>

                <!-- Question 4: Building owner willing to support (only if ownFacility is false) -->
                @if (form.ownFacility === false) {
                  <div class="form-group" style="margin-left: 4rem">
                    <span class="required">{{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.BUILDING_OWNER_WILLING"
                        | translate
                    }}</span>
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.buildingOwnerWillingToSupport"
                          name="buildingOwnerWillingToSupport"
                          value="yes"
                          (ngModelChange)="saveFormData()"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.YES"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.buildingOwnerWillingToSupport"
                          name="buildingOwnerWillingToSupport"
                          value="no"
                          (ngModelChange)="saveFormData()"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NO"
                            | translate
                        }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.buildingOwnerWillingToSupport"
                          name="buildingOwnerWillingToSupport"
                          value="need_support"
                          (ngModelChange)="saveFormData()"
                        />
                        {{
                          "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NEED_SUPPORT"
                            | translate
                        }}
                      </label>
                    </div>
                  </div>
                }
              }

              <div class="form-group">
                <!-- Question 5: Energy-efficient upgrades -->
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.INTERESTED_IN_ENERGY_UPGRADES"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [ngModel]="form.interestedInEnergyUpgrades"
                      name="interestedInEnergyUpgrades"
                      [value]="true"
                      (ngModelChange)="
                        onInterestedInEnergyUpgradesChange($event)
                      "
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.YES"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [ngModel]="form.interestedInEnergyUpgrades"
                      name="interestedInEnergyUpgrades"
                      [value]="false"
                      (ngModelChange)="
                        onInterestedInEnergyUpgradesChange($event)
                      "
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.COMMERCIAL_REAL_ESTATE.NO"
                        | translate
                    }}
                  </label>
                </div>
              </div>
            }

            <!-- Solar and Energy Efficiency Section -->
            @if (getCurrentProductSection() === "solarAndEnergy") {
              <h3>
                {{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.SECTION_TITLE"
                    | translate
                }}
              </h3>
              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.INTERESTED_IN_SOLAR"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInSolarProviderOrLoan"
                      name="interestedInSolarProviderOrLoan"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInSolarProviderOrLoan"
                      name="interestedInSolarProviderOrLoan"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.INTERESTED_IN_EE_UPGRADES"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInEEUpgrades"
                      name="interestedInEEUpgrades"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInEEUpgrades"
                      name="interestedInEEUpgrades"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label for="buildingBuiltYear" class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.BUILDING_BUILT_YEAR"
                    | translate
                }}</label>
                <input
                  id="buildingBuiltYear"
                  type="text"
                  [(ngModel)]="form.buildingBuiltYear"
                  name="buildingBuiltYear"
                  [placeholder]="
                    'GENERAL_OUTREACH_FORM.PLACEHOLDERS.BUSINESS_ESTABLISHED'
                      | translate
                  "
                  (ngModelChange)="saveFormData()"
                  required
                />
                @if (form.buildingBuiltYear && !isBuildingBuiltYearValid()) {
                  <span class="error-message">
                    {{
                      isBuildingBuiltYearInFuture()
                        ? ("GENERAL_OUTREACH_FORM.VALIDATION.BUILDING_BUILT_YEAR_FUTURE"
                          | translate)
                        : ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_BUILDING_BUILT_YEAR"
                          | translate)
                    }}
                  </span>
                }
              </div>

              <div class="form-group">
                <label for="buildingImprovements">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.BUILDING_IMPROVEMENTS"
                    | translate
                }}</label>
                <textarea
                  id="buildingImprovements"
                  [(ngModel)]="form.buildingImprovements"
                  name="buildingImprovements"
                  rows="4"
                  (ngModelChange)="saveFormData()"
                ></textarea>
              </div>

              <div class="form-group">
                <label for="powerUtilityProviders">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.POWER_UTILITY_PROVIDERS"
                    | translate
                }}</label>
                <textarea
                  id="powerUtilityProviders"
                  [(ngModel)]="form.powerUtilityProviders"
                  name="powerUtilityProviders"
                  rows="3"
                  (ngModelChange)="saveFormData()"
                ></textarea>
              </div>

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.INTERESTED_IN_BATTERIES"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInBatteries"
                      name="interestedInBatteries"
                      value="yes"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInBatteries"
                      name="interestedInBatteries"
                      value="no"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.interestedInBatteries"
                      name="interestedInBatteries"
                      value="unsure"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.UNSURE"
                        | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.CAN_PROVIDE_POWER_USE_STATEMENT"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.canProvidePowerUseStatement"
                      name="canProvidePowerUseStatement"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.canProvidePowerUseStatement"
                      name="canProvidePowerUseStatement"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.HAS_ELECTRIC_VEHICLES"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.hasElectricVehicles"
                      name="hasElectricVehicles"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.hasElectricVehicles"
                      name="hasElectricVehicles"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                </div>
              </div>

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.LOOKING_TO_ADD_ELECTRIC_VEHICLE"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.lookingToAddElectricVehicle"
                      name="lookingToAddElectricVehicle"
                      [value]="true"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.lookingToAddElectricVehicle"
                      name="lookingToAddElectricVehicle"
                      [value]="false"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.SOLAR_AND_ENERGY.NO" | translate
                    }}
                  </label>
                </div>
              </div>

              <!-- Credit Score Range - Conditional question shown if not already answered and user needs financing -->
              @if (shouldShowCreditScoreInSolarSection()) {
                <div class="form-group">
                  <label for="creditScoreRange_solar" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CREDIT_SCORE_RANGE_SOLAR"
                      | translate
                  }}</label>
                  <select
                    id="creditScoreRange_solar"
                    [(ngModel)]="form.creditScoreRange"
                    name="creditScoreRange_solar"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('creditScoreRange_solar')"
                    required
                  >
                    <option value="">
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_RANGE" | translate
                      }}
                    </option>
                    <option value="<580">Below 580</option>
                    <option value="580+">580 and above</option>
                    <option value="670+">670 and above</option>
                    <option value="740+">740 and above</option>
                    <option value="800+">800 and above</option>
                  </select>
                </div>
              }
            }

            @if (getCurrentProductSection() === "findingInvestors") {
              <h3>
                {{
                  "GENERAL_OUTREACH_FORM.INTERESTED_PRODUCTS.FINDING_INVESTORS"
                    | translate
                }}
              </h3>
              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.KNOWS_INVESTOR_TYPE"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.knowsInvestorType"
                      name="knowsInvestorType"
                      value="yes"
                      (ngModelChange)="saveFormData()"
                      (focus)="trackFieldInteraction('knowsInvestorType_yes')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.knowsInvestorType"
                      name="knowsInvestorType"
                      value="no"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.NO" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.knowsInvestorType"
                      name="knowsInvestorType"
                      value="need_help"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.NEED_HELP"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.knowsInvestorType"
                      name="knowsInvestorType"
                      value="learn_more"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.STARTUP_LEARN_MORE"
                        | translate
                    }}
                  </label>
                </div>
              </div>

              @if (form.knowsInvestorType === "yes") {
                <fieldset class="form-group">
                  <legend class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.INVESTMENT_TYPE"
                        | translate
                    }}
                  </legend>
                  <div class="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isInvestmentTypeSelected('equity')"
                        (change)="toggleInvestmentType('equity')"
                        name="investmentTypeEquity"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.EQUITY"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isInvestmentTypeSelected('debt')"
                        (change)="toggleInvestmentType('debt')"
                        name="investmentTypeDebt"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.DEBT"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        [checked]="isInvestmentTypeSelected('revenueSharing')"
                        (change)="toggleInvestmentType('revenueSharing')"
                        name="investmentTypeRevenueSharing"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.REVENUE_SHARING"
                          | translate
                      }}
                    </label>
                  </div>
                </fieldset>
              }

              <div class="form-group">
                <span class="required">{{
                  "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.WILLING_TO_RELOCATE"
                    | translate
                }}</span>
                <div class="radio-group">
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.willingToRelocate"
                      name="willingToRelocate"
                      value="yes"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.YES" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.willingToRelocate"
                      name="willingToRelocate"
                      value="no"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.NO" | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="radio"
                      [(ngModel)]="form.willingToRelocate"
                      name="willingToRelocate"
                      value="depends"
                      (ngModelChange)="saveFormData()"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINDING_INVESTORS.DEPENDS"
                        | translate
                    }}
                  </label>
                </div>
              </div>
            }

            <!-- Loans and Capital Products Section -->
            @if (
              getCurrentProductSection() === "loansAndCapital" ||
              isLoanApplication
            ) {
              <!-- Only show these questions for non-loan applications -->
              @if (!isLoanApplication) {
                <h3>
                  {{
                    "GENERAL_OUTREACH_FORM.INTERESTED_PRODUCTS.LOANS_AND_CAPITAL"
                      | translate
                  }}
                </h3>
                <div class="form-group">
                  <label for="hasRegisteredEntity" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.HAS_REGISTERED_ENTITY"
                      | translate
                  }}</label>
                  <div class="radio-group">
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.hasRegisteredEntity"
                        name="hasRegisteredEntity"
                        [value]="true"
                        (ngModelChange)="saveFormData()"
                        (focus)="
                          trackFieldInteraction('hasRegisteredEntity_yes')
                        "
                      />
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.hasRegisteredEntity"
                        name="hasRegisteredEntity"
                        [value]="false"
                        (ngModelChange)="saveFormData()"
                      />
                      {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="capitalAmount" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOAN_AMOUNT" | translate
                  }}</label>
                  <input
                    id="capitalAmount"
                    type="number"
                    [(ngModel)]="form.loanAmount"
                    name="capitalAmount"
                    [class.invalid]="
                      form.loanAmount !== undefined &&
                      form.loanAmount !== null &&
                      !isValidFinancialField('loanAmount')
                    "
                    required
                    min="0"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('loanAmount')"
                  />
                  @if (
                    form.loanAmount !== undefined &&
                    form.loanAmount !== null &&
                    !isValidFinancialField("loanAmount")
                  ) {
                    <span class="error-message">{{
                      getFinancialFieldError("loanAmount") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="loanTermMonths" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOAN_TERM_MONTHS"
                      | translate
                  }}</label>
                  <input
                    id="loanTermMonths"
                    type="number"
                    [(ngModel)]="form.loanTermMonths"
                    name="loanTermMonths"
                    required
                    min="1"
                    [class.invalid]="
                      form.loanTermMonths !== undefined &&
                      form.loanTermMonths !== null &&
                      !isLoanTermMonthsValid()
                    "
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('loanTermMonths')"
                  />
                  @if (
                    form.loanTermMonths !== undefined &&
                    form.loanTermMonths !== null &&
                    !isLoanTermMonthsValid()
                  ) {
                    <span class="error-message">{{
                      "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_MONTHS"
                        | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="totalRevenue" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_REVENUE"
                      | translate
                  }}</label>
                  <div class="current-liabilities-info">
                    <span class="info-icon" aria-label="Info">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="9"
                          stroke="currentColor"
                          stroke-width="2"
                        />
                        <path
                          d="M12 11V16"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                        <circle cx="12" cy="7.5" r="1" fill="currentColor" />
                      </svg>
                    </span>
                    <span class="info-text">{{
                      "GENERAL_OUTREACH_FORM.FIELD_INFO.TOTAL_REVENUE_HELP"
                        | translate
                    }}</span>
                  </div>
                  <input
                    id="totalRevenue"
                    type="number"
                    [(ngModel)]="form.totalRevenue"
                    name="totalRevenue"
                    [class.invalid]="!isValidFinancialField('totalRevenue')"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('totalRevenue')"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("totalRevenue")) {
                    <span class="error-message">{{
                      getFinancialFieldError("totalRevenue") | translate
                    }}</span>
                  }
                </div>

                <fieldset class="form-group">
                  <legend class="required">
                    {{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.CAPITAL_PRODUCT_TYPE"
                        | translate
                    }}
                  </legend>
                  <div class="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_term_loan"
                        value="term_loan"
                        [checked]="
                          form.capitalProductType.includes('term_loan')
                        "
                        (change)="
                          onCapitalProductTypeChange('term_loan', $event)
                        "
                        (focus)="
                          trackFieldInteraction('capitalProductType_term_loan')
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.TERM_LOAN"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_working_capital_loan"
                        value="working_capital_loan"
                        [checked]="
                          form.capitalProductType.includes(
                            'working_capital_loan'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'working_capital_loan',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.WORKING_CAPITAL_LOAN"
                          | translate
                      }}
                    </label>
                    <!-- <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_sba_loan_product"
                        value="sba_loan_product"
                        [checked]="form.capitalProductType.includes('sba_loan_product')"
                        (change)="onCapitalProductTypeChange('sba_loan_product', $event)"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.SBA_LOAN"
                          | translate
                      }}
                    </label> -->
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_business_facility_or_equipment_loan"
                        value="business_facility_or_equipment_loan"
                        [checked]="
                          form.capitalProductType.includes(
                            'business_facility_or_equipment_loan'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'business_facility_or_equipment_loan',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.FACILITY_EQUIPMENT_LOAN"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_refinance_other_debt"
                        value="refinance_other_debt"
                        [checked]="
                          form.capitalProductType.includes(
                            'refinance_other_debt'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'refinance_other_debt',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.REFINANCE_DEBT"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_real_estate_lending_residential"
                        value="real_estate_lending_residential"
                        [checked]="
                          form.capitalProductType.includes(
                            'real_estate_lending_residential'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'real_estate_lending_residential',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.REAL_ESTATE_LENDING_RESIDENTIAL"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_commercial_real_estate_purchase"
                        value="commercial_real_estate_purchase"
                        [checked]="
                          form.capitalProductType.includes(
                            'commercial_real_estate_purchase'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'commercial_real_estate_purchase',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.COMMERCIAL_REAL_ESTATE_PURCHASE"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_start_up_support"
                        value="start_up_support"
                        [checked]="
                          form.capitalProductType.includes('start_up_support')
                        "
                        (change)="
                          onCapitalProductTypeChange('start_up_support', $event)
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.STARTUP_SUPPORT"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_short_term_quick_capital"
                        value="short_term_quick_capital"
                        [checked]="
                          form.capitalProductType.includes(
                            'short_term_quick_capital'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'short_term_quick_capital',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.SHORT_TERM_QUICK_CAPITAL"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_business_acquisition"
                        value="business_acquisition"
                        [checked]="
                          form.capitalProductType.includes(
                            'business_acquisition'
                          )
                        "
                        (change)="
                          onCapitalProductTypeChange(
                            'business_acquisition',
                            $event
                          )
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.BUSINESS_ACQUISITION"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_grant_programs"
                        value="grant_programs"
                        [checked]="
                          form.capitalProductType.includes('grant_programs')
                        "
                        (change)="
                          onCapitalProductTypeChange('grant_programs', $event)
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.GRANT_PROGRAMS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_venture_funding"
                        value="venture_funding"
                        [checked]="
                          form.capitalProductType.includes('venture_funding')
                        "
                        (change)="
                          onCapitalProductTypeChange('venture_funding', $event)
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.VENTURE_FUNDING"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_acquisition_m_a"
                        value="acquisition_m_a"
                        [checked]="
                          form.capitalProductType.includes('acquisition_m_a')
                        "
                        (change)="
                          onCapitalProductTypeChange('acquisition_m_a', $event)
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.ACQUISITION_MA"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="capitalProductType_project_finance"
                        value="project_finance"
                        [checked]="
                          form.capitalProductType.includes('project_finance')
                        "
                        (change)="
                          onCapitalProductTypeChange('project_finance', $event)
                        "
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.CAPITAL_PRODUCTS.PROJECT_FINANCE"
                          | translate
                      }}
                    </label>
                  </div>
                </fieldset>

                @if (
                  form.capitalProductType.length > 0 &&
                  !(
                    form.capitalProductType.length === 1 &&
                    form.capitalProductType.includes("grant_programs")
                  )
                ) {
                  <div class="form-group">
                    <span class="required">{{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.WILL_FILL_PRESCREENING"
                        | translate
                    }}</span>
                    <div class="radio-group">
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.willFillPrescreening"
                          name="willFillPrescreening"
                          [value]="true"
                          (ngModelChange)="onWillFillPrescreeningChange()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                      </label>
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="form.willFillPrescreening"
                          name="willFillPrescreening"
                          [value]="false"
                          (ngModelChange)="onWillFillPrescreeningChange()"
                        />
                        {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                      </label>
                    </div>
                  </div>

                  <!-- Additional questions if user selects No for prescreening -->
                  @if (form.willFillPrescreening === false) {
                    <div class="form-group">
                      <label for="creditScoreRange" class="required">{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.CREDIT_SCORE_RANGE"
                          | translate
                      }}</label>
                      <select
                        id="creditScoreRange"
                        [(ngModel)]="form.creditScoreRange"
                        name="creditScoreRange"
                        (ngModelChange)="saveFormData()"
                        required
                      >
                        <option value="">
                          {{
                            "GENERAL_OUTREACH_FORM.OPTIONS.SELECT_RANGE"
                              | translate
                          }}
                        </option>
                        <option value="<580">Below 580</option>
                        <option value="580+">580 and above</option>
                        <option value="670+">670 and above</option>
                        <option value="740+">740 and above</option>
                        <option value="800+">800 and above</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <span class="required">{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.HAS_CO_SIGNER"
                          | translate
                      }}</span>
                      <div class="radio-group">
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasCoSigner"
                            name="hasCoSigner"
                            [value]="true"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasCoSigner"
                            name="hasCoSigner"
                            [value]="false"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <span class="required">{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.HAS_BUSINESS_PLAN"
                          | translate
                      }}</span>
                      <div class="radio-group">
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasBusinessPlan"
                            name="hasBusinessPlan"
                            value="yes"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasBusinessPlan"
                            name="hasBusinessPlan"
                            value="no"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasBusinessPlan"
                            name="hasBusinessPlan"
                            value="need_help"
                            (ngModelChange)="saveFormData()"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.OPTIONS.NEED_HELP_MAKING_ONE"
                              | translate
                          }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <span class="required">{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.HAS_FINANCIAL_PROJECTIONS"
                          | translate
                      }}</span>
                      <div class="radio-group">
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasFinancialProjections"
                            name="hasFinancialProjections"
                            value="yes"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasFinancialProjections"
                            name="hasFinancialProjections"
                            value="no"
                            (ngModelChange)="saveFormData()"
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.hasFinancialProjections"
                            name="hasFinancialProjections"
                            value="need_help"
                            (ngModelChange)="saveFormData()"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.OPTIONS.NEED_HELP_MAKING_PROJECTIONS"
                              | translate
                          }}
                        </label>
                      </div>
                    </div>

                    <fieldset class="form-group">
                      <legend class="required">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.FINANCIAL_DOCUMENTATION"
                            | translate
                        }}
                      </legend>
                      <div class="checkbox-group">
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isFinancialDocSelected('auditedStatements')
                            "
                            name="auditedStatements"
                            (change)="toggleFinancialDoc('auditedStatements')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.AUDITED_STATEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isFinancialDocSelected('unauditedStatements')
                            "
                            name="unauditedStatements"
                            (change)="toggleFinancialDoc('unauditedStatements')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.UNAUDITED_STATEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isFinancialDocSelected('informalStatements')
                            "
                            name="informalStatements"
                            (change)="toggleFinancialDoc('informalStatements')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.INFORMAL_STATEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isFinancialDocSelected('taxReturns')"
                            name="taxReturns"
                            (change)="toggleFinancialDoc('taxReturns')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.TAX_RETURNS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isFinancialDocSelected('bankStatements')"
                            name="bankStatements"
                            (change)="toggleFinancialDoc('bankStatements')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.BANK_STATEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isFinancialDocSelected('noStatements')"
                            name="noStatements"
                            (change)="toggleFinancialDoc('noStatements')"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.FINANCIAL_DOCS.NO_STATEMENTS"
                              | translate
                          }}
                        </label>
                      </div>
                    </fieldset>
                  }
                }
              }

              <!-- Prescreening form if user selects Yes OR if it's a loan application -->
              @if (form.willFillPrescreening === true || isLoanApplication) {
                <div class="prescreening-form-wrapper">
                  <h3 class="prescreening-form-title">
                    {{
                      "GENERAL_OUTREACH_FORM.SECTION_TITLES.LOAN_PRESCREENING_FORM"
                        | translate
                    }}
                  </h3>

                  <div class="prescreening-form-content">
                    <!-- Ownership Structure Table -->
                    <div class="form-group">
                      <span class="required">{{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNERSHIP_STRUCTURE"
                          | translate
                      }}</span>
                      <div class="info-note mobile-scroll-hint">
                        {{
                          "GENERAL_OUTREACH_FORM.NOTES.MOBILE_TABLE_SCROLL"
                            | translate
                        }}
                      </div>
                      <div class="table-container">
                        <div class="ownership-table">
                          <div class="table-header">
                            <div class="table-cell header-cell">
                              {{
                                "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNER_NAME"
                                  | translate
                              }}
                            </div>
                            <div class="table-cell header-cell">
                              {{
                                "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNERSHIP_PERCENTAGE"
                                  | translate
                              }}
                            </div>
                            <div class="table-cell header-cell">
                              {{
                                "GENERAL_OUTREACH_FORM.FORM_FIELDS.OTHER_BUSINESSES_PERCENTAGE"
                                  | translate
                              }}
                            </div>
                            <div class="table-cell header-cell">
                              {{
                                "GENERAL_OUTREACH_FORM.TABLE_HEADERS.ACTIONS"
                                  | translate
                              }}
                            </div>
                          </div>

                          @for (
                            ownershipRow of form.ownershipStructure || [];
                            track $index
                          ) {
                            <div class="table-row">
                              <div
                                class="table-cell"
                                data-label="Owner Name"
                                style="
                                  flex-direction: column;
                                  align-items: flex-start;
                                "
                              >
                                <input
                                  type="text"
                                  [(ngModel)]="ownershipRow.ownerName"
                                  [name]="'ownerName_' + $index"
                                  #ownerNameInput1="ngModel"
                                  [placeholder]="
                                    $index === 0
                                      ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                        | translate)
                                      : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME'
                                        | translate)
                                  "
                                  [class.required-field]="$index === 0"
                                  [class.invalid]="
                                    ownerNameInput1.touched &&
                                    $index === 0 &&
                                    (!ownershipRow.ownerName ||
                                      !ownershipRow.ownerName.trim())
                                  "
                                  (ngModelChange)="onOwnershipChange()"
                                />
                                @if (
                                  ownerNameInput1.touched &&
                                  $index === 0 &&
                                  (!ownershipRow.ownerName ||
                                    !ownershipRow.ownerName.trim())
                                ) {
                                  <span
                                    class="error-message"
                                    style="
                                      margin-top: 2px;
                                      font-size: 0.75rem;
                                      white-space: nowrap;
                                    "
                                  >
                                    {{
                                      "GENERAL_OUTREACH_FORM.VALIDATION.REQUIRED"
                                        | translate
                                    }}
                                  </span>
                                }
                              </div>
                              <div
                                class="table-cell"
                                data-label="% Ownership"
                                style="
                                  flex-direction: column;
                                  align-items: flex-start;
                                "
                              >
                                <input
                                  type="number"
                                  [(ngModel)]="ownershipRow.ownershipPercentage"
                                  [name]="'ownershipPercentage_' + $index"
                                  #ownerPctInput1="ngModel"
                                  min="0"
                                  max="100"
                                  [placeholder]="
                                    $index === 0
                                      ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                        | translate)
                                      : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERCENTAGE_0_100'
                                        | translate)
                                  "
                                  [class.required-field]="$index === 0"
                                  [class.invalid]="
                                    ownerPctInput1.touched &&
                                    ($index === 0
                                      ? ownershipRow.ownershipPercentage ===
                                          undefined ||
                                        ownershipRow.ownershipPercentage ===
                                          null ||
                                        ownershipRow.ownershipPercentage < 0 ||
                                        ownershipRow.ownershipPercentage >
                                          100 ||
                                        !isValidDecimal(
                                          ownershipRow.ownershipPercentage
                                        )
                                      : ownershipRow.ownershipPercentage !==
                                          undefined &&
                                        ownershipRow.ownershipPercentage !==
                                          null &&
                                        (ownershipRow.ownershipPercentage < 0 ||
                                          ownershipRow.ownershipPercentage >
                                            100 ||
                                          !isValidDecimal(
                                            ownershipRow.ownershipPercentage
                                          )))
                                  "
                                  (ngModelChange)="onOwnershipChange()"
                                  (wheel)="$event.preventDefault()"
                                />
                                @if (
                                  ownerPctInput1.touched &&
                                  ($index === 0
                                    ? ownershipRow.ownershipPercentage ===
                                        undefined ||
                                      ownershipRow.ownershipPercentage ===
                                        null ||
                                      ownershipRow.ownershipPercentage < 0 ||
                                      ownershipRow.ownershipPercentage > 100 ||
                                      !isValidDecimal(
                                        ownershipRow.ownershipPercentage
                                      )
                                    : ownershipRow.ownershipPercentage !==
                                        undefined &&
                                      ownershipRow.ownershipPercentage !==
                                        null &&
                                      (ownershipRow.ownershipPercentage < 0 ||
                                        ownershipRow.ownershipPercentage >
                                          100 ||
                                        !isValidDecimal(
                                          ownershipRow.ownershipPercentage
                                        )))
                                ) {
                                  <span
                                    class="error-message"
                                    style="
                                      margin-top: 2px;
                                      font-size: 0.75rem;
                                      white-space: nowrap;
                                    "
                                  >
                                    {{
                                      ownershipRow.ownershipPercentage ===
                                        undefined ||
                                      ownershipRow.ownershipPercentage === null
                                        ? ("GENERAL_OUTREACH_FORM.VALIDATION.REQUIRED"
                                          | translate)
                                        : !isValidDecimal(
                                              ownershipRow.ownershipPercentage
                                            )
                                          ? ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_DECIMAL_PLACES"
                                            | translate)
                                          : ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERCENTAGE"
                                            | translate)
                                    }}
                                  </span>
                                }
                              </div>
                              <div
                                class="table-cell"
                                data-label="% Other Businesses"
                                style="
                                  flex-direction: column;
                                  align-items: flex-start;
                                "
                              >
                                <input
                                  type="number"
                                  [(ngModel)]="
                                    ownershipRow.otherBusinessesPercentage
                                  "
                                  [name]="'otherBusinessesPercentage_' + $index"
                                  #otherPctInput1="ngModel"
                                  min="0"
                                  max="100"
                                  [placeholder]="
                                    $index === 0
                                      ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                        | translate)
                                      : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERCENTAGE_0_100'
                                        | translate)
                                  "
                                  [class.required-field]="$index === 0"
                                  [class.invalid]="
                                    otherPctInput1.touched &&
                                    !isOtherBusinessesPercentageValid($index)
                                  "
                                  (ngModelChange)="onOwnershipChange()"
                                  (wheel)="$event.preventDefault()"
                                  style="margin-right: 5px"
                                />
                                @if (
                                  otherPctInput1.touched &&
                                  !isOtherBusinessesPercentageValid($index)
                                ) {
                                  <span
                                    class="error-message"
                                    style="
                                      margin-top: 2px;
                                      font-size: 0.75rem;
                                      white-space: nowrap;
                                    "
                                    >{{
                                      ownershipRow.otherBusinessesPercentage !==
                                        undefined &&
                                      ownershipRow.otherBusinessesPercentage !==
                                        null &&
                                      !isValidDecimal(
                                        ownershipRow.otherBusinessesPercentage
                                      )
                                        ? ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_DECIMAL_PLACES"
                                          | translate)
                                        : ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERCENTAGE"
                                          | translate)
                                    }}</span
                                  >
                                }
                              </div>
                              <div class="table-cell actions-cell">
                                @if ($index === 0) {
                                  <button
                                    type="button"
                                    class="add-button"
                                    (click)="addOwnershipRow()"
                                    [disabled]="!canAddOwnershipRow()"
                                    [title]="
                                      canAddOwnershipRow()
                                        ? 'Add new owner'
                                        : 'Please fill all current rows before adding a new one'
                                    "
                                  >
                                    <img
                                      src="/assets/icons/add.svg"
                                      alt="Add"
                                    />
                                  </button>
                                } @else {
                                  <button
                                    type="button"
                                    class="remove-button"
                                    (click)="removeOwnershipRow($index)"
                                    title="Remove owner"
                                  >
                                    <img
                                      src="/assets/icons/delete.svg"
                                      alt="Remove"
                                    />
                                  </button>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      @if (!isOwnershipStructureValid()) {
                        <span class="error-message">{{
                          "GENERAL_OUTREACH_FORM.VALIDATION.OWNERSHIP_STRUCTURE_INVALID"
                            | translate
                        }}</span>
                      }
                    </div>

                    <!-- Project Description -->
                    <fieldset class="form-group">
                      <legend class="required">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.PROJECT_DESCRIPTION"
                            | translate
                        }}
                      </legend>
                      <div class="checkbox-group">
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected(
                                'businessAcquisition'
                              )
                            "
                            (change)="
                              toggleProjectDescription(
                                'businessAcquisition',
                                $event
                              )
                            "
                            name="businessAcquisition"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.BUSINESS_ACQUISITION"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected(
                                'equipmentMaintenance'
                              )
                            "
                            (change)="
                              toggleProjectDescription(
                                'equipmentMaintenance',
                                $event
                              )
                            "
                            name="equipmentMaintenance"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.EQUIPMENT_MAINTENANCE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('businessExpansion')
                            "
                            (change)="
                              toggleProjectDescription(
                                'businessExpansion',
                                $event
                              )
                            "
                            name="businessExpansion"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.BUSINESS_EXPANSION"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('equipmentPurchase')
                            "
                            (change)="
                              toggleProjectDescription(
                                'equipmentPurchase',
                                $event
                              )
                            "
                            name="equipmentPurchase"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.EQUIPMENT_PURCHASE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('realEstatePurchase')
                            "
                            (change)="
                              toggleProjectDescription(
                                'realEstatePurchase',
                                $event
                              )
                            "
                            name="realEstatePurchase"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_PURCHASE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected(
                                'realEstateConstruction'
                              )
                            "
                            (change)="
                              toggleProjectDescription(
                                'realEstateConstruction',
                                $event
                              )
                            "
                            name="realEstateConstruction"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_CONSTRUCTION"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected(
                                'realEstateImprovements'
                              )
                            "
                            (change)="
                              toggleProjectDescription(
                                'realEstateImprovements',
                                $event
                              )
                            "
                            name="realEstateImprovements"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_IMPROVEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected(
                                'refinanceBusinessDebt'
                              )
                            "
                            (change)="
                              toggleProjectDescription(
                                'refinanceBusinessDebt',
                                $event
                              )
                            "
                            name="refinanceBusinessDebt"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REFINANCE_BUSINESS_DEBT"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('refinanceOtherLoan')
                            "
                            (change)="
                              toggleProjectDescription(
                                'refinanceOtherLoan',
                                $event
                              )
                            "
                            name="refinanceOtherLoan"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REFINANCE_OTHER_LOAN"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('solarImprovements')
                            "
                            (change)="
                              toggleProjectDescription(
                                'solarImprovements',
                                $event
                              )
                            "
                            name="solarImprovements"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.SOLAR_IMPROVEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('startupActivity')
                            "
                            (change)="
                              toggleProjectDescription(
                                'startupActivity',
                                $event
                              )
                            "
                            name="startupActivity"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.STARTUP_ACTIVITY"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('vehiclePurchase')
                            "
                            (change)="
                              toggleProjectDescription(
                                'vehiclePurchase',
                                $event
                              )
                            "
                            name="vehiclePurchase"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.VEHICLE_PURCHASE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isProjectDescriptionSelected('purchaseInventory')
                            "
                            (change)="
                              toggleProjectDescription(
                                'purchaseInventory',
                                $event
                              )
                            "
                            name="purchaseInventory"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.PURCHASE_INVENTORY"
                              | translate
                          }}
                        </label>
                      </div>
                    </fieldset>

                    <div class="form-group">
                      <label
                        for="contributingPersonalCapital"
                        class="required"
                        >{{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONTRIBUTING_PERSONAL_CAPITAL"
                            | translate
                        }}</label
                      >
                      <div class="radio-group">
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.contributingPersonalCapital"
                            name="contributingPersonalCapital"
                            [value]="true"
                            required
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                        </label>
                        <label>
                          <input
                            type="radio"
                            [(ngModel)]="form.contributingPersonalCapital"
                            name="contributingPersonalCapital"
                            [value]="false"
                            required
                          />
                          {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                        </label>
                      </div>
                    </div>

                    @if (form.contributingPersonalCapital === true) {
                      <div class="form-group">
                        <label
                          for="personalCapitalPercentage"
                          class="required"
                          >{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_CAPITAL_PERCENTAGE"
                              | translate
                          }}</label
                        >
                        <input
                          id="personalCapitalPercentage"
                          type="number"
                          [(ngModel)]="form.personalCapitalPercentage"
                          name="personalCapitalPercentage"
                          min="0"
                          max="100"
                          [class.invalid]="
                            form.personalCapitalPercentage !== undefined &&
                            !isPersonalCapitalPercentageValid()
                          "
                          required
                          (ngModelChange)="saveFormData()"
                          (wheel)="$event.preventDefault()"
                        />
                        @if (
                          form.personalCapitalPercentage !== undefined &&
                          !isPersonalCapitalPercentageValid()
                        ) {
                          <span class="error-message">{{
                            "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERSONAL_CAPITAL_PERCENTAGE"
                              | translate
                          }}</span>
                        }
                      </div>
                    }

                    <fieldset class="form-group">
                      <legend class="required">
                        {{
                          "GENERAL_OUTREACH_FORM.FORM_FIELDS.COLLATERAL_TYPES"
                            | translate
                        }}
                      </legend>
                      <div class="checkbox-group">
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('realEstateBuilding')
                            "
                            (change)="
                              toggleCollateralType('realEstateBuilding', $event)
                            "
                            name="collateralRealEstateBuilding"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.REAL_ESTATE_BUILDING"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('land')"
                            (change)="toggleCollateralType('land', $event)"
                            name="collateralLand"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.LAND"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('equipment')"
                            (change)="toggleCollateralType('equipment', $event)"
                            name="collateralEquipment"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.EQUIPMENT"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('vehicle')"
                            (change)="toggleCollateralType('vehicle', $event)"
                            name="collateralVehicle"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.VEHICLE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('thirdPartyGuarantees')
                            "
                            (change)="
                              toggleCollateralType(
                                'thirdPartyGuarantees',
                                $event
                              )
                            "
                            name="collateralThirdPartyGuarantees"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.THIRD_PARTY_GUARANTEES"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('residentialRealEstate')
                            "
                            (change)="
                              toggleCollateralType(
                                'residentialRealEstate',
                                $event
                              )
                            "
                            name="collateralResidentialRealEstate"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.RESIDENTIAL_REAL_ESTATE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('inventory')"
                            (change)="toggleCollateralType('inventory', $event)"
                            name="collateralInventory"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.INVENTORY"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('accountsReceivable')
                            "
                            (change)="
                              toggleCollateralType('accountsReceivable', $event)
                            "
                            name="collateralAccountsReceivable"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.ACCOUNTS_RECEIVABLE"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('cash')"
                            (change)="toggleCollateralType('cash', $event)"
                            name="collateralCash"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.CASH"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('investmentAccounts')
                            "
                            (change)="
                              toggleCollateralType('investmentAccounts', $event)
                            "
                            name="collateralInvestmentAccounts"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.INVESTMENT_ACCOUNTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('furnitureAndFixtures')
                            "
                            (change)="
                              toggleCollateralType(
                                'furnitureAndFixtures',
                                $event
                              )
                            "
                            name="collateralFurnitureAndFixtures"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.FURNITURE_AND_FIXTURES"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('newEquipmentMachinery')
                            "
                            (change)="
                              toggleCollateralType(
                                'newEquipmentMachinery',
                                $event
                              )
                            "
                            name="collateralNewEquipmentMachinery"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.NEW_EQUIPMENT_MACHINERY"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="
                              isCollateralTypeSelected('leaseholdImprovements')
                            "
                            (change)="
                              toggleCollateralType(
                                'leaseholdImprovements',
                                $event
                              )
                            "
                            name="collateralLeaseholdImprovements"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.LEASEHOLD_IMPROVEMENTS"
                              | translate
                          }}
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            [checked]="isCollateralTypeSelected('noCollateral')"
                            (change)="
                              toggleCollateralType('noCollateral', $event)
                            "
                            name="collateralNoCollateral"
                          />
                          {{
                            "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.NO_COLLATERAL"
                              | translate
                          }}
                        </label>
                      </div>
                    </fieldset>

                    <!-- Financial Information -->
                    <div class="financial-form-section">
                      <!-- Funding Consideration Info Box -->
                      <div class="info-note funding-consideration">
                        <span
                          class="guidance-text"
                          [innerHTML]="
                            'GENERAL_OUTREACH_FORM.GUIDANCE.FUNDING_CONSIDERATION'
                              | translate
                          "
                        >
                        </span>
                      </div>

                      <!-- Income/Revenue Section -->
                      <div class="financial-section-wrapper">
                        <h3>
                          {{
                            "GENERAL_OUTREACH_FORM.SECTION_TITLES.INCOME_REVENUE"
                              | translate
                          }}
                        </h3>

                        <!-- Common guidance for all financial fields -->
                        <div class="common-field-guidance">
                          <div class="guidance-box">
                            <span
                              class="guidance-text"
                              [innerHTML]="
                                'GENERAL_OUTREACH_FORM.GUIDANCE.FINANCIAL_FIELDS'
                                  | translate
                              "
                            >
                            </span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="reportingPeriod" class="required">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.REPORTING_PERIOD"
                              | translate
                          }}</label>
                          <div class="radio-group">
                            <span style="font-size: 14px">Period ending:</span>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="form.reportingPeriod"
                                name="reportingPeriod"
                                value="Q1"
                                required
                                (ngModelChange)="saveFormData()"
                              />
                              Q1
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="form.reportingPeriod"
                                name="reportingPeriod"
                                value="Q2"
                                required
                                (ngModelChange)="saveFormData()"
                              />
                              Q2
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="form.reportingPeriod"
                                name="reportingPeriod"
                                value="Q3"
                                required
                                (ngModelChange)="saveFormData()"
                              />
                              Q3
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="form.reportingPeriod"
                                name="reportingPeriod"
                                value="Q4"
                                required
                                (ngModelChange)="saveFormData()"
                              />
                              Q4
                            </label>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="periodMonths" class="required">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERIOD_MONTHS"
                              | translate
                          }}</label>
                          <div class="radio-group">
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="periodMonthsSelection"
                                name="periodMonthsSelection"
                                value="6"
                                required
                                (change)="onPeriodMonthsChange()"
                                (ngModelChange)="saveFormData()"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_6_MONTHS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="periodMonthsSelection"
                                name="periodMonthsSelection"
                                value="9"
                                required
                                (change)="onPeriodMonthsChange()"
                                (ngModelChange)="saveFormData()"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_9_MONTHS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="periodMonthsSelection"
                                name="periodMonthsSelection"
                                value="12"
                                required
                                (change)="onPeriodMonthsChange()"
                                (ngModelChange)="saveFormData()"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_12_MONTHS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="radio"
                                [(ngModel)]="periodMonthsSelection"
                                name="periodMonthsSelection"
                                value="other"
                                required
                                (change)="onPeriodMonthsChange()"
                                (ngModelChange)="saveFormData()"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_OTHER"
                                  | translate
                              }}
                            </label>
                          </div>
                          <div class="info-note">
                            Note: 12 months period preferable (e.g. period
                            ending Q2 2024 through Q2 2025)
                          </div>
                        </div>
                        <!-- Custom period months input when "Other" is selected -->
                        @if (periodMonthsSelection === "other") {
                          <div class="form-group">
                            <label for="customPeriodMonths" class="required">{{
                              "GENERAL_OUTREACH_FORM.FORM_FIELDS.CUSTOM_PERIOD_MONTHS"
                                | translate
                            }}</label>
                            <input
                              id="customPeriodMonths"
                              type="number"
                              [(ngModel)]="form.customPeriodMonths"
                              name="customPeriodMonths"
                              min="1"
                              max="60"
                              placeholder="{{
                                'GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERIOD_MONTHS_CONSTRAINT'
                                  | translate
                              }}"
                              required
                              (ngModelChange)="onCustomPeriodMonthsChange()"
                              (wheel)="$event.preventDefault()"
                            />
                          </div>
                        }

                        <div class="form-group">
                          <label for="netProfit">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.NET_PROFIT"
                              | translate
                          }}</label>
                          <input
                            id="netProfit"
                            type="number"
                            [(ngModel)]="form.netProfit"
                            name="netProfit"
                            [class.invalid]="
                              !isValidFinancialField('netProfit')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("netProfit")) {
                            <span class="error-message">{{
                              getFinancialFieldError("netProfit") | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="depreciationAmortization">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.DEPRECIATION_AMORTIZATION"
                              | translate
                          }}</label>
                          <input
                            id="depreciationAmortization"
                            type="number"
                            [(ngModel)]="form.depreciationAmortization"
                            name="depreciationAmortization"
                            [class.invalid]="
                              !isValidFinancialField('depreciationAmortization')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (
                            !isValidFinancialField("depreciationAmortization")
                          ) {
                            <span class="error-message">{{
                              getFinancialFieldError("depreciationAmortization")
                                | translate
                            }}</span>
                          }
                        </div>
                      </div>

                      <!-- Assets & Working Capital Section -->
                      <div class="financial-section-wrapper">
                        <h3>
                          {{
                            "GENERAL_OUTREACH_FORM.SECTION_TITLES.ASSETS_WORKING_CAPITAL"
                              | translate
                          }}
                        </h3>

                        <!-- Assets section guidance -->
                        <div class="common-field-guidance">
                          <div class="guidance-box">
                            <span
                              class="guidance-text"
                              [innerHTML]="
                                'GENERAL_OUTREACH_FORM.GUIDANCE.ASSETS_LIABILITIES'
                                  | translate
                              "
                            >
                            </span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="totalAssets">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_ASSETS"
                              | translate
                          }}</label>
                          <input
                            id="totalAssets"
                            type="number"
                            [(ngModel)]="form.totalAssets"
                            name="totalAssets"
                            [class.invalid]="
                              !isValidFinancialField('totalAssets')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("totalAssets")) {
                            <span class="error-message">{{
                              getFinancialFieldError("totalAssets") | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="cashEquivalents">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.CASH_EQUIVALENTS"
                              | translate
                          }}</label>
                          <input
                            id="cashEquivalents"
                            type="number"
                            [(ngModel)]="form.cashEquivalents"
                            name="cashEquivalents"
                            [class.invalid]="
                              !isValidFinancialField('cashEquivalents')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("cashEquivalents")) {
                            <span class="error-message">{{
                              getFinancialFieldError("cashEquivalents")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="receivables">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.RECEIVABLES"
                              | translate
                          }}</label>
                          <input
                            id="receivables"
                            type="number"
                            [(ngModel)]="form.receivables"
                            name="receivables"
                            [class.invalid]="
                              !isValidFinancialField('receivables')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("receivables")) {
                            <span class="error-message">{{
                              getFinancialFieldError("receivables") | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="inventoryValue">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.INVENTORY_VALUE"
                              | translate
                          }}</label>
                          <input
                            id="inventoryValue"
                            type="number"
                            [(ngModel)]="form.inventoryValue"
                            name="inventoryValue"
                            [class.invalid]="
                              !isValidFinancialField('inventoryValue')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("inventoryValue")) {
                            <span class="error-message">{{
                              getFinancialFieldError("inventoryValue")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="currentLiabilities">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.CURRENT_LIABILITIES"
                              | translate
                          }}</label>
                          <div class="current-liabilities-info">
                            <span class="info-icon">ℹ️</span>
                            <span class="info-text">{{
                              "GENERAL_OUTREACH_FORM.FIELD_INFO.CURRENT_LIABILITIES_HELP"
                                | translate
                            }}</span>
                          </div>
                          <input
                            id="currentLiabilities"
                            type="number"
                            [(ngModel)]="form.currentLiabilities"
                            name="currentLiabilities"
                            [class.invalid]="
                              !isValidFinancialField('currentLiabilities')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("currentLiabilities")) {
                            <span class="error-message">{{
                              getFinancialFieldError("currentLiabilities")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="shareholderEquity">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.SHAREHOLDER_EQUITY"
                              | translate
                          }}</label>
                          <input
                            id="shareholderEquity"
                            type="number"
                            [(ngModel)]="form.shareholderEquity"
                            name="shareholderEquity"
                            [class.invalid]="
                              !isValidFinancialField('shareholderEquity')
                            "
                            [class.invalid]="!isNetWorthOrAlternativeValid()"
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("shareholderEquity")) {
                            <span class="error-message">{{
                              getFinancialFieldError("shareholderEquity")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="alternativeNetWorth">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.ALTERNATIVE_NET_WORTH"
                              | translate
                          }}</label>
                          <div class="current-liabilities-info">
                            <span class="info-icon">ℹ️</span>
                            <span class="info-text">{{
                              "GENERAL_OUTREACH_FORM.FIELD_INFO.ALTERNATIVE_NET_WORTH_HELP"
                                | translate
                            }}</span>
                          </div>
                          <input
                            id="alternativeNetWorth"
                            type="number"
                            [(ngModel)]="form.alternativeNetWorth"
                            name="alternativeNetWorth"
                            [class.invalid]="
                              !isValidFinancialField('alternativeNetWorth')
                            "
                            [class.invalid]="!isNetWorthOrAlternativeValid()"
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("alternativeNetWorth")) {
                            <span class="error-message">{{
                              getFinancialFieldError("alternativeNetWorth")
                                | translate
                            }}</span>
                          }
                        </div>

                        @if (!isNetWorthOrAlternativeValid()) {
                          <div class="error-message">
                            {{
                              "GENERAL_OUTREACH_FORM.VALIDATION.NET_WORTH_REQUIRED"
                                | translate
                            }}
                          </div>
                        }
                      </div>

                      <!-- Existing Debt Section -->
                      <div class="financial-section-wrapper">
                        <h3>
                          {{
                            "GENERAL_OUTREACH_FORM.SECTION_TITLES.EXISTING_DEBT"
                              | translate
                          }}
                        </h3>

                        <!-- Existing debt section guidance -->
                        <div class="common-field-guidance">
                          <div class="guidance-box">
                            <span
                              class="guidance-text"
                              [innerHTML]="
                                'GENERAL_OUTREACH_FORM.GUIDANCE.DEBT_INFORMATION'
                                  | translate
                              "
                            >
                            </span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="existingLoansAmount">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.EXISTING_LOANS_AMOUNT"
                              | translate
                          }}</label>
                          <input
                            id="existingLoansAmount"
                            type="number"
                            [(ngModel)]="form.existingLoansAmount"
                            name="existingLoansAmount"
                            [class.invalid]="
                              !isValidFinancialField('existingLoansAmount')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("existingLoansAmount")) {
                            <span class="error-message">{{
                              getFinancialFieldError("existingLoansAmount")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="creditLinesLimit">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.CREDIT_LINES_LIMIT"
                              | translate
                          }}</label>
                          <input
                            id="creditLinesLimit"
                            type="number"
                            [(ngModel)]="form.creditLinesLimit"
                            name="creditLinesLimit"
                            [class.invalid]="
                              !isValidFinancialField('creditLinesLimit')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("creditLinesLimit")) {
                            <span class="error-message">{{
                              getFinancialFieldError("creditLinesLimit")
                                | translate
                            }}</span>
                          }
                        </div>

                        <div class="form-group">
                          <label for="monthlyDebtService">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.MONTHLY_DEBT_SERVICE"
                              | translate
                          }}</label>
                          <input
                            id="monthlyDebtService"
                            type="number"
                            [(ngModel)]="form.monthlyDebtService"
                            name="monthlyDebtService"
                            [class.invalid]="
                              !isValidFinancialField('monthlyDebtService')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("monthlyDebtService")) {
                            <span class="error-message">{{
                              getFinancialFieldError("monthlyDebtService")
                                | translate
                            }}</span>
                          }
                          @if (isMonthlyDebtServiceWarningVisible()) {
                            <div
                              class="error-message"
                              style="
                                background-color: #fff3cd;
                                color: #856404;
                                border: 1px solid #ffeaa7;
                                padding: 8px;
                                border-radius: 4px;
                              "
                            >
                              {{
                                "GENERAL_OUTREACH_FORM.VALIDATION.MONTHLY_DEBT_SERVICE_WARNING"
                                  | translate
                              }}
                            </div>
                          }
                        </div>
                      </div>

                      <!-- Personal Financial Information Section -->
                      <fieldset
                        class="form-group"
                        style="margin: 15px 0px; padding-top: 15px"
                      >
                        <legend>
                          {{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_FINANCIAL_INFO"
                              | translate
                          }}
                        </legend>

                        <!-- Common guidance for personal financial fields -->
                        <div
                          class="common-field-guidance"
                          style="margin-top: 0px"
                        >
                          <div class="guidance-box">
                            <span
                              class="guidance-text"
                              [innerHTML]="
                                'GENERAL_OUTREACH_FORM.GUIDANCE.PERSONAL_FINANCIAL_FIELDS'
                                  | translate
                              "
                            >
                            </span>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="totalPersonalIncome">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_PERSONAL_INCOME"
                              | translate
                          }}</label>
                          <input
                            id="totalPersonalIncome"
                            type="number"
                            [(ngModel)]="form.totalPersonalIncome"
                            name="totalPersonalIncome"
                            [class.invalid]="
                              !isValidFinancialField('totalPersonalIncome')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("totalPersonalIncome")) {
                            <span class="error-message">{{
                              getFinancialFieldError("totalPersonalIncome")
                                | translate
                            }}</span>
                          }
                          @if (isPersonalIncomeWarningVisible()) {
                            <div
                              class="error-message"
                              style="
                                background-color: #fff3cd;
                                color: #856404;
                                border: 1px solid #ffeaa7;
                                padding: 8px;
                                border-radius: 4px;
                              "
                            >
                              {{
                                "GENERAL_OUTREACH_FORM.VALIDATION.PERSONAL_INCOME_WARNING"
                                  | translate
                              }}
                            </div>
                          }
                        </div>

                        <div class="form-group">
                          <label for="personalNetWorth">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_NET_WORTH"
                              | translate
                          }}</label>
                          <input
                            id="personalNetWorth"
                            type="number"
                            [(ngModel)]="form.personalNetWorth"
                            name="personalNetWorth"
                            [class.invalid]="
                              !isValidFinancialField('personalNetWorth')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("personalNetWorth")) {
                            <span class="error-message">{{
                              getFinancialFieldError("personalNetWorth")
                                | translate
                            }}</span>
                          }
                          @if (isPersonalNetWorthWarningVisible()) {
                            <div
                              class="error-message"
                              style="
                                background-color: #fff3cd;
                                color: #856404;
                                border: 1px solid #ffeaa7;
                                padding: 8px;
                                border-radius: 4px;
                              "
                            >
                              {{
                                "GENERAL_OUTREACH_FORM.VALIDATION.PERSONAL_NET_WORTH_WARNING"
                                  | translate
                              }}
                            </div>
                          }
                        </div>

                        <div class="form-group">
                          <label for="personalLoansAmount">{{
                            "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_LOANS_AMOUNT"
                              | translate
                          }}</label>
                          <input
                            id="personalLoansAmount"
                            type="number"
                            [(ngModel)]="form.personalLoansAmount"
                            name="personalLoansAmount"
                            [class.invalid]="
                              !isValidFinancialField('personalLoansAmount')
                            "
                            (ngModelChange)="saveFormData()"
                            (wheel)="$event.preventDefault()"
                          />
                          @if (!isValidFinancialField("personalLoansAmount")) {
                            <span class="error-message">{{
                              getFinancialFieldError("personalLoansAmount")
                                | translate
                            }}</span>
                          }
                        </div>
                      </fieldset>

                      @if (!isLoanApplication) {
                        <fieldset class="form-group">
                          <legend class="required">
                            {{
                              "GENERAL_OUTREACH_FORM.FORM_FIELDS.FINANCIAL_DOCUMENTATION"
                                | translate
                            }}
                          </legend>
                          <div class="checkbox-group">
                            <label>
                              <input
                                type="checkbox"
                                [checked]="
                                  isFinancialDocSelected('auditedStatements')
                                "
                                name="auditedStatements"
                                (change)="
                                  toggleFinancialDoc('auditedStatements')
                                "
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.AUDITED_STATEMENTS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                [checked]="
                                  isFinancialDocSelected('unauditedStatements')
                                "
                                name="unauditedStatements"
                                (change)="
                                  toggleFinancialDoc('unauditedStatements')
                                "
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.UNAUDITED_STATEMENTS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                [checked]="
                                  isFinancialDocSelected('informalStatements')
                                "
                                name="informalStatements"
                                (change)="
                                  toggleFinancialDoc('informalStatements')
                                "
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.INFORMAL_STATEMENTS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                [checked]="isFinancialDocSelected('taxReturns')"
                                name="taxReturns"
                                (change)="toggleFinancialDoc('taxReturns')"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.TAX_RETURNS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                [checked]="
                                  isFinancialDocSelected('noStatements')
                                "
                                name="noStatements"
                                (change)="toggleFinancialDoc('noStatements')"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.NO_STATEMENTS"
                                  | translate
                              }}
                            </label>
                            <label>
                              <input
                                type="checkbox"
                                [checked]="
                                  isFinancialDocSelected('bankStatements')
                                "
                                name="bankStatements"
                                (change)="toggleFinancialDoc('bankStatements')"
                              />
                              {{
                                "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.BANK_STATEMENTS"
                                  | translate
                              }}
                            </label>
                          </div>
                        </fieldset>
                      }
                    </div>
                  </div>
                </div>
              }
            }

            <!-- Error messages and submit button for loan applications -->
            @if (isLoanApplication) {
              @if (submitError) {
                <div class="error-message-container" style="margin-top: 15px">
                  <p class="error-message">{{ submitError }}</p>
                  @if (submitFieldErrors.length > 0) {
                    <ul class="error-list">
                      @for (error of submitFieldErrors; track error) {
                        <li class="error-message">{{ error }}</li>
                      }
                    </ul>
                  }
                </div>
              }

              <div class="form-actions">
                <button
                  type="button"
                  (click)="onSubmitLoanApplication()"
                  [disabled]="!isCurrentSectionValid() || isSubmitting"
                >
                  @if (isSubmitting) {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMITTING" | translate }}
                  } @else {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT" | translate }}
                  }
                </button>
              </div>
            }

            <!-- Regular form navigation for multi-step form -->
            @if (!isLoanApplication) {
              <div class="form-actions">
                @if (currentSection > 0) {
                  <button type="button" class="back-button" (click)="onBack()">
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.BACK" | translate }}
                  </button>
                }
                <button type="submit" [disabled]="!isCurrentSectionValid()">
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.NEXT" | translate }}
                </button>
              </div>
            }
          </div>
        }

        <!-- Section 1b - Alternative Info (DEPRECATED - not used in multi-page flow) -->
        @if (false && currentSection === 3) {
          <div class="form-section">
            <!-- Business Established and Number of Employees -->
            <div class="form-group">
              <label for="businessEstablished" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.BUSINESS_ESTABLISHED"
                  | translate
              }}</label>
              <input
                id="businessEstablished"
                type="text"
                [(ngModel)]="form.businessEstablished"
                name="businessEstablished"
                [placeholder]="
                  'GENERAL_OUTREACH_FORM.PLACEHOLDERS.BUSINESS_ESTABLISHED'
                    | translate
                "
                required
                (ngModelChange)="onBusinessEstablishedChange()"
              />
              @if (form.businessEstablished && !isBusinessEstablishedValid()) {
                <span class="error-message">{{
                  "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_BUSINESS_ESTABLISHED"
                    | translate
                }}</span>
              }
            </div>
            <div class="form-group">
              <label for="numberOfEmployees" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.NUMBER_OF_FTE" | translate
              }}</label>
              <input
                id="numberOfEmployees"
                type="number"
                step="1"
                [(ngModel)]="form.numberOfEmployees"
                name="numberOfEmployees"
                placeholder="{{
                  'GENERAL_OUTREACH_FORM.PLACEHOLDERS.EMPLOYEES_CONSTRAINT'
                    | translate
                }}"
                min="0"
                required
                [class.invalid]="!isNumberOfEmployeesValid()"
                (ngModelChange)="onNumberOfEmployeesChange($event)"
                (keydown)="restrictIntegerInput($event)"
                (wheel)="$event.preventDefault()"
              />
              @if (!isNumberOfEmployeesValid()) {
                <span class="error-message">{{
                  getFinancialFieldError("numberOfEmployees") | translate
                }}</span>
              }
              @if (shouldShowBusinessAgeEmployeeAlert()) {
                <div class="info-note warning">
                  {{
                    "GENERAL_OUTREACH_FORM.VALIDATION.BUSINESS_AGE_EMPLOYEE_WARNING"
                      | translate
                  }}
                </div>
              }
            </div>

            <!-- Ownership Structure Table -->
            <div class="form-group">
              <span class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNERSHIP_STRUCTURE"
                  | translate
              }}</span>
              <div class="info-note mobile-scroll-hint">
                {{
                  "GENERAL_OUTREACH_FORM.NOTES.MOBILE_TABLE_SCROLL" | translate
                }}
              </div>
              <div class="table-container">
                <div class="ownership-table">
                  <div class="table-header">
                    <div class="table-cell header-cell">
                      {{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNER_NAME"
                          | translate
                      }}
                    </div>
                    <div class="table-cell header-cell">
                      {{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.OWNERSHIP_PERCENTAGE"
                          | translate
                      }}
                    </div>
                    <div class="table-cell header-cell">
                      {{
                        "GENERAL_OUTREACH_FORM.FORM_FIELDS.OTHER_BUSINESSES_PERCENTAGE"
                          | translate
                      }}
                    </div>
                    <div class="table-cell header-cell">
                      {{
                        "GENERAL_OUTREACH_FORM.TABLE_HEADERS.ACTIONS"
                          | translate
                      }}
                    </div>
                  </div>

                  @for (
                    ownershipRow of form.ownershipStructure || [];
                    track $index
                  ) {
                    <div class="table-row">
                      <div
                        class="table-cell"
                        data-label="Owner Name"
                        style="flex-direction: column; align-items: flex-start"
                      >
                        <input
                          type="text"
                          [(ngModel)]="ownershipRow.ownerName"
                          [name]="'ownerName_' + $index"
                          #ownerNameInput2="ngModel"
                          [placeholder]="
                            $index === 0
                              ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                | translate)
                              : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME'
                                | translate)
                          "
                          [class.required-field]="$index === 0"
                          [class.invalid]="
                            ownerNameInput2.touched &&
                            $index === 0 &&
                            (!ownershipRow.ownerName ||
                              !ownershipRow.ownerName.trim())
                          "
                          (ngModelChange)="onOwnershipChange()"
                        />
                        @if (
                          ownerNameInput2.touched &&
                          $index === 0 &&
                          (!ownershipRow.ownerName ||
                            !ownershipRow.ownerName.trim())
                        ) {
                          <span
                            class="error-message"
                            style="
                              margin-top: 2px;
                              font-size: 0.75rem;
                              white-space: nowrap;
                            "
                          >
                            {{
                              "GENERAL_OUTREACH_FORM.VALIDATION.REQUIRED"
                                | translate
                            }}
                          </span>
                        }
                      </div>
                      <div
                        class="table-cell"
                        data-label="% Ownership"
                        style="flex-direction: column; align-items: flex-start"
                      >
                        <input
                          type="number"
                          [(ngModel)]="ownershipRow.ownershipPercentage"
                          [name]="'ownershipPercentage_' + $index"
                          #ownerPctInput2="ngModel"
                          min="0"
                          max="100"
                          [placeholder]="
                            $index === 0
                              ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                | translate)
                              : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERCENTAGE_0_100'
                                | translate)
                          "
                          [class.required-field]="$index === 0"
                          [class.invalid]="
                            ownerPctInput2.touched &&
                            ($index === 0
                              ? ownershipRow.ownershipPercentage ===
                                  undefined ||
                                ownershipRow.ownershipPercentage === null ||
                                ownershipRow.ownershipPercentage < 0 ||
                                ownershipRow.ownershipPercentage > 100 ||
                                !isValidDecimal(
                                  ownershipRow.ownershipPercentage
                                )
                              : ownershipRow.ownershipPercentage !==
                                  undefined &&
                                ownershipRow.ownershipPercentage !== null &&
                                (ownershipRow.ownershipPercentage < 0 ||
                                  ownershipRow.ownershipPercentage > 100 ||
                                  !isValidDecimal(
                                    ownershipRow.ownershipPercentage
                                  )))
                          "
                          (ngModelChange)="onOwnershipChange()"
                          (wheel)="$event.preventDefault()"
                        />
                        @if (
                          ownerPctInput2.touched &&
                          ($index === 0
                            ? ownershipRow.ownershipPercentage === undefined ||
                              ownershipRow.ownershipPercentage === null ||
                              ownershipRow.ownershipPercentage < 0 ||
                              ownershipRow.ownershipPercentage > 100 ||
                              !isValidDecimal(ownershipRow.ownershipPercentage)
                            : ownershipRow.ownershipPercentage !== undefined &&
                              ownershipRow.ownershipPercentage !== null &&
                              (ownershipRow.ownershipPercentage < 0 ||
                                ownershipRow.ownershipPercentage > 100 ||
                                !isValidDecimal(
                                  ownershipRow.ownershipPercentage
                                )))
                        ) {
                          <span
                            class="error-message"
                            style="
                              margin-top: 2px;
                              font-size: 0.75rem;
                              white-space: nowrap;
                            "
                          >
                            {{
                              ownershipRow.ownershipPercentage === undefined ||
                              ownershipRow.ownershipPercentage === null
                                ? ("GENERAL_OUTREACH_FORM.VALIDATION.REQUIRED"
                                  | translate)
                                : !isValidDecimal(
                                      ownershipRow.ownershipPercentage
                                    )
                                  ? ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_DECIMAL_PLACES"
                                    | translate)
                                  : ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERCENTAGE"
                                    | translate)
                            }}
                          </span>
                        }
                      </div>
                      <div
                        class="table-cell"
                        data-label="% Other Businesses"
                        style="flex-direction: column; align-items: flex-start"
                      >
                        <input
                          type="number"
                          [(ngModel)]="ownershipRow.otherBusinessesPercentage"
                          [name]="'otherBusinessesPercentage_' + $index"
                          #otherPctInput2="ngModel"
                          min="0"
                          max="100"
                          [placeholder]="
                            $index === 0
                              ? ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.OWNER_NAME_REQUIRED'
                                | translate)
                              : ('GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERCENTAGE_0_100'
                                | translate)
                          "
                          [class.required-field]="$index === 0"
                          [class.invalid]="
                            otherPctInput2.touched &&
                            !isOtherBusinessesPercentageValid($index)
                          "
                          (ngModelChange)="onOwnershipChange()"
                          (wheel)="$event.preventDefault()"
                          style="margin-right: 5px"
                        />
                        @if (
                          otherPctInput2.touched &&
                          !isOtherBusinessesPercentageValid($index)
                        ) {
                          <span
                            class="error-message"
                            style="
                              margin-top: 2px;
                              font-size: 0.75rem;
                              white-space: nowrap;
                            "
                            >{{
                              ownershipRow.otherBusinessesPercentage !==
                                undefined &&
                              ownershipRow.otherBusinessesPercentage !== null &&
                              !isValidDecimal(
                                ownershipRow.otherBusinessesPercentage
                              )
                                ? ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_DECIMAL_PLACES"
                                  | translate)
                                : ("GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERCENTAGE"
                                  | translate)
                            }}</span
                          >
                        }
                      </div>
                      <div class="table-cell actions-cell">
                        @if ($index === 0) {
                          <button
                            type="button"
                            class="add-button"
                            (click)="addOwnershipRow()"
                            [disabled]="!canAddOwnershipRow()"
                            [title]="
                              canAddOwnershipRow()
                                ? 'Add new owner'
                                : 'Please fill all current rows before adding a new one'
                            "
                          >
                            <img src="/assets/icons/add.svg" alt="Add" />
                          </button>
                        } @else {
                          <button
                            type="button"
                            class="remove-button"
                            (click)="removeOwnershipRow($index)"
                            title="Remove owner"
                          >
                            <img src="/assets/icons/delete.svg" alt="Remove" />
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (!isOwnershipStructureValid()) {
                <span class="error-message">{{
                  "GENERAL_OUTREACH_FORM.VALIDATION.OWNERSHIP_STRUCTURE_INVALID"
                    | translate
                }}</span>
              }
            </div>

            <div class="form-group">
              <label for="loanAmount" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOAN_AMOUNT" | translate
              }}</label>
              <input
                id="loanAmount"
                type="number"
                [(ngModel)]="form.loanAmount"
                name="loanAmount"
                [class.invalid]="
                  form.loanAmount !== undefined &&
                  form.loanAmount !== null &&
                  !isValidFinancialField('loanAmount')
                "
                required
                (ngModelChange)="saveFormData()"
                (wheel)="$event.preventDefault()"
              />
              @if (
                form.loanAmount !== undefined &&
                form.loanAmount !== null &&
                !isValidFinancialField("loanAmount")
              ) {
                <span class="error-message">{{
                  getFinancialFieldError("loanAmount") | translate
                }}</span>
              }
            </div>

            <div class="form-group">
              <label for="loanTermMonths" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.LOAN_TERM_MONTHS" | translate
              }}</label>
              <input
                id="loanTermMonths"
                type="number"
                [(ngModel)]="form.loanTermMonths"
                name="loanTermMonths"
                placeholder="{{
                  'GENERAL_OUTREACH_FORM.PLACEHOLDERS.LOAN_TERM_CONSTRAINT'
                    | translate
                }}"
                required
                min="1"
                [class.invalid]="
                  form.loanTermMonths !== undefined &&
                  form.loanTermMonths !== null &&
                  !isLoanTermMonthsValid()
                "
                (ngModelChange)="saveFormData()"
                (wheel)="$event.preventDefault()"
              />
              @if (
                form.loanTermMonths !== undefined &&
                form.loanTermMonths !== null &&
                !isLoanTermMonthsValid()
              ) {
                <span class="error-message">{{
                  "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_MONTHS" | translate
                }}</span>
              }
            </div>

            <div class="form-group">
              <label for="totalRevenue" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_REVENUE" | translate
              }}</label>
              <div class="current-liabilities-info">
                <span class="info-icon" aria-label="Info">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke="currentColor"
                      stroke-width="2"
                    />
                    <path
                      d="M12 11V16"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <circle cx="12" cy="7.5" r="1" fill="currentColor" />
                  </svg>
                </span>
                <span class="info-text">{{
                  "GENERAL_OUTREACH_FORM.FIELD_INFO.TOTAL_REVENUE_HELP"
                    | translate
                }}</span>
              </div>
              <input
                id="totalRevenue"
                type="number"
                [(ngModel)]="form.totalRevenue"
                name="totalRevenue"
                [class.invalid]="!isValidFinancialField('totalRevenue')"
                (ngModelChange)="saveFormData()"
                (wheel)="$event.preventDefault()"
              />
              @if (!isValidFinancialField("totalRevenue")) {
                <span class="error-message">{{
                  getFinancialFieldError("totalRevenue") | translate
                }}</span>
              }
            </div>

            <!-- Section 1a Loan Term -->
            <fieldset class="form-group">
              <legend class="required">
                {{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.PROJECT_DESCRIPTION"
                    | translate
                }}
              </legend>
              <div class="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('businessAcquisition')
                    "
                    (change)="
                      toggleProjectDescription('businessAcquisition', $event)
                    "
                    name="businessAcquisition"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.BUSINESS_ACQUISITION"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('equipmentMaintenance')
                    "
                    (change)="
                      toggleProjectDescription('equipmentMaintenance', $event)
                    "
                    name="equipmentMaintenance"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.EQUIPMENT_MAINTENANCE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('businessExpansion')
                    "
                    (change)="
                      toggleProjectDescription('businessExpansion', $event)
                    "
                    name="businessExpansion"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.BUSINESS_EXPANSION"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('equipmentPurchase')
                    "
                    (change)="
                      toggleProjectDescription('equipmentPurchase', $event)
                    "
                    name="equipmentPurchase"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.EQUIPMENT_PURCHASE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('realEstatePurchase')
                    "
                    (change)="
                      toggleProjectDescription('realEstatePurchase', $event)
                    "
                    name="realEstatePurchase"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_PURCHASE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('realEstateConstruction')
                    "
                    (change)="
                      toggleProjectDescription('realEstateConstruction', $event)
                    "
                    name="realEstateConstruction"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_CONSTRUCTION"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('realEstateImprovements')
                    "
                    (change)="
                      toggleProjectDescription('realEstateImprovements', $event)
                    "
                    name="realEstateImprovements"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REAL_ESTATE_IMPROVEMENTS"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('refinanceBusinessDebt')
                    "
                    (change)="
                      toggleProjectDescription('refinanceBusinessDebt', $event)
                    "
                    name="refinanceBusinessDebt"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REFINANCE_BUSINESS_DEBT"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('refinanceOtherLoan')
                    "
                    (change)="
                      toggleProjectDescription('refinanceOtherLoan', $event)
                    "
                    name="refinanceOtherLoan"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.REFINANCE_OTHER_LOAN"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('solarImprovements')
                    "
                    (change)="
                      toggleProjectDescription('solarImprovements', $event)
                    "
                    name="solarImprovements"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.SOLAR_IMPROVEMENTS"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isProjectDescriptionSelected('startupActivity')"
                    (change)="
                      toggleProjectDescription('startupActivity', $event)
                    "
                    name="startupActivity"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.STARTUP_ACTIVITY"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isProjectDescriptionSelected('vehiclePurchase')"
                    (change)="
                      toggleProjectDescription('vehiclePurchase', $event)
                    "
                    name="vehiclePurchase"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.VEHICLE_PURCHASE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isProjectDescriptionSelected('purchaseInventory')
                    "
                    (change)="
                      toggleProjectDescription('purchaseInventory', $event)
                    "
                    name="purchaseInventory"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.PROJECT_DESCRIPTION.PURCHASE_INVENTORY"
                      | translate
                  }}
                </label>
              </div>
            </fieldset>

            <div class="form-group">
              <label for="contributingPersonalCapital" class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONTRIBUTING_PERSONAL_CAPITAL"
                  | translate
              }}</label>
              <div class="radio-group">
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.contributingPersonalCapital"
                    name="contributingPersonalCapital"
                    [value]="true"
                    required
                  />
                  {{ "GENERAL_OUTREACH_FORM.OPTIONS.YES" | translate }}
                </label>
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.contributingPersonalCapital"
                    name="contributingPersonalCapital"
                    [value]="false"
                    required
                  />
                  {{ "GENERAL_OUTREACH_FORM.OPTIONS.NO" | translate }}
                </label>
              </div>
            </div>

            @if (form.contributingPersonalCapital === true) {
              <div class="form-group">
                <label for="personalCapitalPercentage" class="required">{{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_CAPITAL_PERCENTAGE"
                    | translate
                }}</label>
                <input
                  id="personalCapitalPercentage"
                  type="number"
                  [(ngModel)]="form.personalCapitalPercentage"
                  name="personalCapitalPercentage"
                  placeholder="{{
                    'GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERSONAL_CAPITAL_CONSTRAINT'
                      | translate
                  }}"
                  min="0"
                  max="100"
                  [class.invalid]="
                    form.personalCapitalPercentage !== undefined &&
                    !isPersonalCapitalPercentageValid()
                  "
                  required
                  (ngModelChange)="saveFormData()"
                  (wheel)="$event.preventDefault()"
                />
                @if (
                  form.personalCapitalPercentage !== undefined &&
                  !isPersonalCapitalPercentageValid()
                ) {
                  <span class="error-message">{{
                    "GENERAL_OUTREACH_FORM.VALIDATION.INVALID_PERSONAL_CAPITAL_PERCENTAGE"
                      | translate
                  }}</span>
                }
              </div>
            }

            <fieldset class="form-group">
              <legend class="required">
                {{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.COLLATERAL_TYPES"
                    | translate
                }}
              </legend>
              <div class="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('realEstateBuilding')"
                    (change)="
                      toggleCollateralType('realEstateBuilding', $event)
                    "
                    name="collateralRealEstateBuilding"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.REAL_ESTATE_BUILDING"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('land')"
                    (change)="toggleCollateralType('land', $event)"
                    name="collateralLand"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.LAND" | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('equipment')"
                    (change)="toggleCollateralType('equipment', $event)"
                    name="collateralEquipment"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.EQUIPMENT"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('vehicle')"
                    (change)="toggleCollateralType('vehicle', $event)"
                    name="collateralVehicle"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.VEHICLE" | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('thirdPartyGuarantees')"
                    (change)="
                      toggleCollateralType('thirdPartyGuarantees', $event)
                    "
                    name="collateralThirdPartyGuarantees"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.THIRD_PARTY_GUARANTEES"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isCollateralTypeSelected('residentialRealEstate')
                    "
                    (change)="
                      toggleCollateralType('residentialRealEstate', $event)
                    "
                    name="collateralResidentialRealEstate"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.RESIDENTIAL_REAL_ESTATE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('inventory')"
                    (change)="toggleCollateralType('inventory', $event)"
                    name="collateralInventory"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.INVENTORY"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('accountsReceivable')"
                    (change)="
                      toggleCollateralType('accountsReceivable', $event)
                    "
                    name="collateralAccountsReceivable"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.ACCOUNTS_RECEIVABLE"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('cash')"
                    (change)="toggleCollateralType('cash', $event)"
                    name="collateralCash"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.CASH" | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('investmentAccounts')"
                    (change)="
                      toggleCollateralType('investmentAccounts', $event)
                    "
                    name="collateralInvestmentAccounts"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.INVESTMENT_ACCOUNTS"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('furnitureAndFixtures')"
                    (change)="
                      toggleCollateralType('furnitureAndFixtures', $event)
                    "
                    name="collateralFurnitureAndFixtures"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.FURNITURE_AND_FIXTURES"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isCollateralTypeSelected('newEquipmentMachinery')
                    "
                    (change)="
                      toggleCollateralType('newEquipmentMachinery', $event)
                    "
                    name="collateralNewEquipmentMachinery"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.NEW_EQUIPMENT_MACHINERY"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="
                      isCollateralTypeSelected('leaseholdImprovements')
                    "
                    (change)="
                      toggleCollateralType('leaseholdImprovements', $event)
                    "
                    name="collateralLeaseholdImprovements"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.LEASEHOLD_IMPROVEMENTS"
                      | translate
                  }}
                </label>
                <label>
                  <input
                    type="checkbox"
                    [checked]="isCollateralTypeSelected('noCollateral')"
                    (change)="toggleCollateralType('noCollateral', $event)"
                    name="collateralNoCollateral"
                  />
                  {{
                    "GENERAL_OUTREACH_FORM.COLLATERAL_TYPES.NO_COLLATERAL"
                      | translate
                  }}
                </label>
              </div>
            </fieldset>

            <!-- Financial Information -->
            <div class="form-section">
              <!-- Funding Consideration Info Box -->
              <div class="info-note funding-consideration">
                <span
                  class="guidance-text"
                  [innerHTML]="
                    'GENERAL_OUTREACH_FORM.GUIDANCE.FUNDING_CONSIDERATION'
                      | translate
                  "
                >
                </span>
              </div>

              <!-- Income/Revenue Section -->
              <div class="financial-section-wrapper">
                <h3>
                  {{
                    "GENERAL_OUTREACH_FORM.SECTION_TITLES.INCOME_REVENUE"
                      | translate
                  }}
                </h3>

                <!-- Common guidance for all financial fields -->
                <div class="common-field-guidance">
                  <div class="guidance-box">
                    <span
                      class="guidance-text"
                      [innerHTML]="
                        'GENERAL_OUTREACH_FORM.GUIDANCE.FINANCIAL_FIELDS'
                          | translate
                      "
                    >
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="reportingPeriod" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.REPORTING_PERIOD"
                      | translate
                  }}</label>
                  <div class="radio-group">
                    <span style="font-size: 14px">Period ending:</span>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.reportingPeriod"
                        name="reportingPeriod"
                        value="Q1"
                        required
                        (ngModelChange)="saveFormData()"
                      />
                      Q1
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.reportingPeriod"
                        name="reportingPeriod"
                        value="Q2"
                        required
                        (ngModelChange)="saveFormData()"
                      />
                      Q2
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.reportingPeriod"
                        name="reportingPeriod"
                        value="Q3"
                        required
                        (ngModelChange)="saveFormData()"
                      />
                      Q3
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="form.reportingPeriod"
                        name="reportingPeriod"
                        value="Q4"
                        required
                        (ngModelChange)="saveFormData()"
                      />
                      Q4
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="periodMonths" class="required">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERIOD_MONTHS"
                      | translate
                  }}</label>
                  <div class="radio-group">
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="periodMonthsSelection"
                        name="periodMonthsSelection"
                        value="6"
                        required
                        (change)="onPeriodMonthsChange()"
                        (ngModelChange)="saveFormData()"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_6_MONTHS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="periodMonthsSelection"
                        name="periodMonthsSelection"
                        value="9"
                        required
                        (change)="onPeriodMonthsChange()"
                        (ngModelChange)="saveFormData()"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_9_MONTHS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="periodMonthsSelection"
                        name="periodMonthsSelection"
                        value="12"
                        required
                        (change)="onPeriodMonthsChange()"
                        (ngModelChange)="saveFormData()"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_12_MONTHS"
                          | translate
                      }}
                    </label>
                    <label>
                      <input
                        type="radio"
                        [(ngModel)]="periodMonthsSelection"
                        name="periodMonthsSelection"
                        value="other"
                        required
                        (change)="onPeriodMonthsChange()"
                        (ngModelChange)="saveFormData()"
                      />
                      {{
                        "GENERAL_OUTREACH_FORM.OPTIONS.PERIOD_OTHER" | translate
                      }}
                    </label>
                  </div>
                  <div class="info-note">
                    Note: 12 months period preferable (e.g. period ending Q2
                    2024 through Q2 2025)
                  </div>
                </div>
                <!-- Custom period months input when "Other" is selected -->
                @if (periodMonthsSelection === "other") {
                  <div class="form-group">
                    <label for="customPeriodMonths" class="required">{{
                      "GENERAL_OUTREACH_FORM.FORM_FIELDS.CUSTOM_PERIOD_MONTHS"
                        | translate
                    }}</label>
                    <input
                      id="customPeriodMonths"
                      type="number"
                      [(ngModel)]="form.customPeriodMonths"
                      name="customPeriodMonths"
                      min="1"
                      max="60"
                      placeholder="{{
                        'GENERAL_OUTREACH_FORM.PLACEHOLDERS.PERIOD_MONTHS_CONSTRAINT'
                          | translate
                      }}"
                      required
                      (ngModelChange)="onCustomPeriodMonthsChange()"
                      (wheel)="$event.preventDefault()"
                    />
                  </div>
                }

                <div class="form-group">
                  <label for="netProfit">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.NET_PROFIT" | translate
                  }}</label>
                  <input
                    id="netProfit"
                    type="number"
                    [(ngModel)]="form.netProfit"
                    name="netProfit"
                    [class.invalid]="!isValidFinancialField('netProfit')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("netProfit")) {
                    <span class="error-message">{{
                      getFinancialFieldError("netProfit") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="depreciationAmortization">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.DEPRECIATION_AMORTIZATION"
                      | translate
                  }}</label>
                  <input
                    id="depreciationAmortization"
                    type="number"
                    [(ngModel)]="form.depreciationAmortization"
                    name="depreciationAmortization"
                    [class.invalid]="
                      !isValidFinancialField('depreciationAmortization')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("depreciationAmortization")) {
                    <span class="error-message">{{
                      getFinancialFieldError("depreciationAmortization")
                        | translate
                    }}</span>
                  }
                </div>
              </div>

              <!-- Assets & Working Capital Section -->
              <div class="financial-section-wrapper">
                <h3>
                  {{
                    "GENERAL_OUTREACH_FORM.SECTION_TITLES.ASSETS_WORKING_CAPITAL"
                      | translate
                  }}
                </h3>

                <!-- Assets section guidance -->
                <div class="common-field-guidance">
                  <div class="guidance-box">
                    <span
                      class="guidance-text"
                      [innerHTML]="
                        'GENERAL_OUTREACH_FORM.GUIDANCE.ASSETS_LIABILITIES'
                          | translate
                      "
                    >
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="totalAssets">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_ASSETS" | translate
                  }}</label>
                  <input
                    id="totalAssets"
                    type="number"
                    [(ngModel)]="form.totalAssets"
                    name="totalAssets"
                    [class.invalid]="!isValidFinancialField('totalAssets')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("totalAssets")) {
                    <span class="error-message">{{
                      getFinancialFieldError("totalAssets") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="cashEquivalents">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CASH_EQUIVALENTS"
                      | translate
                  }}</label>
                  <input
                    id="cashEquivalents"
                    type="number"
                    [(ngModel)]="form.cashEquivalents"
                    name="cashEquivalents"
                    [class.invalid]="!isValidFinancialField('cashEquivalents')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("cashEquivalents")) {
                    <span class="error-message">{{
                      getFinancialFieldError("cashEquivalents") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="receivables">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.RECEIVABLES" | translate
                  }}</label>
                  <input
                    id="receivables"
                    type="number"
                    [(ngModel)]="form.receivables"
                    name="receivables"
                    [class.invalid]="!isValidFinancialField('receivables')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("receivables")) {
                    <span class="error-message">{{
                      getFinancialFieldError("receivables") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="inventoryValue">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.INVENTORY_VALUE"
                      | translate
                  }}</label>
                  <input
                    id="inventoryValue"
                    type="number"
                    [(ngModel)]="form.inventoryValue"
                    name="inventoryValue"
                    [class.invalid]="!isValidFinancialField('inventoryValue')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("inventoryValue")) {
                    <span class="error-message">{{
                      getFinancialFieldError("inventoryValue") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="currentLiabilities">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CURRENT_LIABILITIES"
                      | translate
                  }}</label>
                  <div class="current-liabilities-info">
                    <span class="info-icon">ℹ️</span>
                    <span class="info-text">{{
                      "GENERAL_OUTREACH_FORM.FIELD_INFO.CURRENT_LIABILITIES_HELP"
                        | translate
                    }}</span>
                  </div>
                  <input
                    id="currentLiabilities"
                    type="number"
                    [(ngModel)]="form.currentLiabilities"
                    name="currentLiabilities"
                    [class.invalid]="
                      !isValidFinancialField('currentLiabilities')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("currentLiabilities")) {
                    <span class="error-message">{{
                      getFinancialFieldError("currentLiabilities") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="shareholderEquity">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.SHAREHOLDER_EQUITY"
                      | translate
                  }}</label>
                  <input
                    id="shareholderEquity"
                    type="number"
                    [(ngModel)]="form.shareholderEquity"
                    name="shareholderEquity"
                    [class.invalid]="
                      !isValidFinancialField('shareholderEquity')
                    "
                    [class.invalid]="!isNetWorthOrAlternativeValid()"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("shareholderEquity")) {
                    <span class="error-message">{{
                      getFinancialFieldError("shareholderEquity") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="alternativeNetWorth">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.ALTERNATIVE_NET_WORTH"
                      | translate
                  }}</label>
                  <div class="current-liabilities-info">
                    <span class="info-icon">ℹ️</span>
                    <span class="info-text">{{
                      "GENERAL_OUTREACH_FORM.FIELD_INFO.ALTERNATIVE_NET_WORTH_HELP"
                        | translate
                    }}</span>
                  </div>
                  <input
                    id="alternativeNetWorth"
                    type="number"
                    [(ngModel)]="form.alternativeNetWorth"
                    name="alternativeNetWorth"
                    [class.invalid]="
                      !isValidFinancialField('alternativeNetWorth')
                    "
                    [class.invalid]="!isNetWorthOrAlternativeValid()"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("alternativeNetWorth")) {
                    <span class="error-message">{{
                      getFinancialFieldError("alternativeNetWorth") | translate
                    }}</span>
                  }
                </div>

                @if (!isNetWorthOrAlternativeValid()) {
                  <div class="error-message">
                    {{
                      "GENERAL_OUTREACH_FORM.VALIDATION.NET_WORTH_REQUIRED"
                        | translate
                    }}
                  </div>
                }
              </div>

              <!-- Existing Debt Section -->
              <div class="financial-section-wrapper">
                <h3>
                  {{
                    "GENERAL_OUTREACH_FORM.SECTION_TITLES.EXISTING_DEBT"
                      | translate
                  }}
                </h3>

                <!-- Existing debt section guidance -->
                <div class="common-field-guidance">
                  <div class="guidance-box">
                    <span
                      class="guidance-text"
                      [innerHTML]="
                        'GENERAL_OUTREACH_FORM.GUIDANCE.DEBT_INFORMATION'
                          | translate
                      "
                    >
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="existingLoansAmount">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.EXISTING_LOANS_AMOUNT"
                      | translate
                  }}</label>
                  <input
                    id="existingLoansAmount"
                    type="number"
                    [(ngModel)]="form.existingLoansAmount"
                    name="existingLoansAmount"
                    [class.invalid]="
                      !isValidFinancialField('existingLoansAmount')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("existingLoansAmount")) {
                    <span class="error-message">{{
                      getFinancialFieldError("existingLoansAmount") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="creditLinesLimit">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CREDIT_LINES_LIMIT"
                      | translate
                  }}</label>
                  <input
                    id="creditLinesLimit"
                    type="number"
                    [(ngModel)]="form.creditLinesLimit"
                    name="creditLinesLimit"
                    [class.invalid]="!isValidFinancialField('creditLinesLimit')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("creditLinesLimit")) {
                    <span class="error-message">{{
                      getFinancialFieldError("creditLinesLimit") | translate
                    }}</span>
                  }
                </div>

                <div class="form-group">
                  <label for="monthlyDebtService">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.MONTHLY_DEBT_SERVICE"
                      | translate
                  }}</label>
                  <input
                    id="monthlyDebtService"
                    type="number"
                    [(ngModel)]="form.monthlyDebtService"
                    name="monthlyDebtService"
                    [class.invalid]="
                      !isValidFinancialField('monthlyDebtService')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("monthlyDebtService")) {
                    <span class="error-message">{{
                      getFinancialFieldError("monthlyDebtService") | translate
                    }}</span>
                  }
                  @if (isMonthlyDebtServiceWarningVisible()) {
                    <div
                      class="error-message"
                      style="
                        background-color: #fff3cd;
                        color: #856404;
                        border: 1px solid #ffeaa7;
                        padding: 8px;
                        border-radius: 4px;
                      "
                    >
                      {{
                        "GENERAL_OUTREACH_FORM.VALIDATION.MONTHLY_DEBT_SERVICE_WARNING"
                          | translate
                      }}
                    </div>
                  }
                </div>
              </div>

              <!-- Personal Financial Information Section -->
              <fieldset
                class="form-group"
                style="margin: 15px 0px; padding-top: 15px"
              >
                <legend>
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_FINANCIAL_INFO"
                      | translate
                  }}
                </legend>

                <!-- Common guidance for personal financial fields -->
                <div class="common-field-guidance" style="margin-top: 0px">
                  <div class="guidance-box">
                    <span
                      class="guidance-text"
                      [innerHTML]="
                        'GENERAL_OUTREACH_FORM.GUIDANCE.PERSONAL_FINANCIAL_FIELDS'
                          | translate
                      "
                    >
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="totalPersonalIncome">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.TOTAL_PERSONAL_INCOME"
                      | translate
                  }}</label>
                  <input
                    id="totalPersonalIncome"
                    type="number"
                    [(ngModel)]="form.totalPersonalIncome"
                    name="totalPersonalIncome"
                    [class.invalid]="
                      !isValidFinancialField('totalPersonalIncome')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("totalPersonalIncome")) {
                    <span class="error-message">{{
                      getFinancialFieldError("totalPersonalIncome") | translate
                    }}</span>
                  }
                  @if (isPersonalIncomeWarningVisible()) {
                    <div
                      class="error-message"
                      style="
                        background-color: #fff3cd;
                        color: #856404;
                        border: 1px solid #ffeaa7;
                        padding: 8px;
                        border-radius: 4px;
                      "
                    >
                      {{
                        "GENERAL_OUTREACH_FORM.VALIDATION.PERSONAL_INCOME_WARNING"
                          | translate
                      }}
                    </div>
                  }
                </div>

                <div class="form-group">
                  <label for="personalNetWorth">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_NET_WORTH"
                      | translate
                  }}</label>
                  <input
                    id="personalNetWorth"
                    type="number"
                    [(ngModel)]="form.personalNetWorth"
                    name="personalNetWorth"
                    [class.invalid]="!isValidFinancialField('personalNetWorth')"
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("personalNetWorth")) {
                    <span class="error-message">{{
                      getFinancialFieldError("personalNetWorth") | translate
                    }}</span>
                  }
                  @if (isPersonalNetWorthWarningVisible()) {
                    <div
                      class="error-message"
                      style="
                        background-color: #fff3cd;
                        color: #856404;
                        border: 1px solid #ffeaa7;
                        padding: 8px;
                        border-radius: 4px;
                      "
                    >
                      {{
                        "GENERAL_OUTREACH_FORM.VALIDATION.PERSONAL_NET_WORTH_WARNING"
                          | translate
                      }}
                    </div>
                  }
                </div>

                <div class="form-group">
                  <label for="personalLoansAmount">{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.PERSONAL_LOANS_AMOUNT"
                      | translate
                  }}</label>
                  <input
                    id="personalLoansAmount"
                    type="number"
                    [(ngModel)]="form.personalLoansAmount"
                    name="personalLoansAmount"
                    [class.invalid]="
                      !isValidFinancialField('personalLoansAmount')
                    "
                    (ngModelChange)="saveFormData()"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (!isValidFinancialField("personalLoansAmount")) {
                    <span class="error-message">{{
                      getFinancialFieldError("personalLoansAmount") | translate
                    }}</span>
                  }
                </div>
              </fieldset>

              <fieldset class="form-group">
                <legend class="required">
                  {{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.FINANCIAL_DOCUMENTATION"
                      | translate
                  }}
                </legend>
                <div class="checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('auditedStatements')"
                      name="auditedStatements"
                      (change)="toggleFinancialDoc('auditedStatements')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.AUDITED_STATEMENTS"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('unauditedStatements')"
                      name="unauditedStatements"
                      (change)="toggleFinancialDoc('unauditedStatements')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.UNAUDITED_STATEMENTS"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('informalStatements')"
                      name="informalStatements"
                      (change)="toggleFinancialDoc('informalStatements')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.INFORMAL_STATEMENTS"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('taxReturns')"
                      name="taxReturns"
                      (change)="toggleFinancialDoc('taxReturns')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.TAX_RETURNS"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('noStatements')"
                      name="noStatements"
                      (change)="toggleFinancialDoc('noStatements')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.NO_STATEMENTS"
                        | translate
                    }}
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      [checked]="isFinancialDocSelected('bankStatements')"
                      name="bankStatements"
                      (change)="toggleFinancialDoc('bankStatements')"
                    />
                    {{
                      "GENERAL_OUTREACH_FORM.FINANCIAL_DOCUMENTATION.BANK_STATEMENTS"
                        | translate
                    }}
                  </label>
                </div>
              </fieldset>
            </div>

            <!-- Show loan application submission error if any -->
            @if (isLoanApplication && submitError) {
              <div class="error-message-container" style="margin-top: 15px">
                <p class="error-message">{{ submitError }}</p>
                @if (submitFieldErrors.length > 0) {
                  <ul class="error-list">
                    @for (error of submitFieldErrors; track error) {
                      <li class="error-message">{{ error }}</li>
                    }
                  </ul>
                }
              </div>
            }

            <div class="form-actions">
              @if (!isLoanApplication) {
                @if (currentSection > 0) {
                  <button type="button" class="back-button" (click)="onBack()">
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.BACK" | translate }}
                  </button>
                }
                <button type="submit" [disabled]="!isCurrentSectionValid()">
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.NEXT" | translate }}
                </button>
              } @else {
                <button
                  type="submit"
                  (click)="onSubmitLoanApplication()"
                  [disabled]="!isCurrentSectionValid()"
                >
                  @if (isSubmitting) {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMITTING" | translate }}
                  } @else {
                    {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT" | translate }}
                  }
                </button>
              }
            </div>
          </div>
        }

        <!-- Final Consent Section - Show after all product sections are completed -->
        @if (
          currentSection > 0 &&
          !getCurrentProductSection() &&
          form.wantsDetailedQuestionnaire === true
        ) {
          <div class="form-section" style="margin-top: 25px">
            <!-- Connection to ACC Network Question -->
            <div class="form-group">
              <span class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.WANTS_TO_CONNECT" | translate
              }}</span>
              <div class="radio-group">
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.wantsToConnect"
                    name="wantsToConnect"
                    [value]="true"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('wantsToConnect_yes')"
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.wantsToConnect"
                    name="wantsToConnect"
                    [value]="false"
                    (ngModelChange)="saveFormData()"
                  />
                  No
                </label>
              </div>
              @if (form.wantsToConnect === false) {
                <div class="info-note" style="margin-top: 10px">
                  {{
                    "GENERAL_OUTREACH_FORM.NOTES.CONNECT_WARNING" | translate
                  }}
                </div>
              }
            </div>

            <!-- Email Copy Question -->
            <div class="form-group">
              <span class="required">{{
                "GENERAL_OUTREACH_FORM.FORM_FIELDS.WANTS_FORM_COPY" | translate
              }}</span>
              <div class="radio-group">
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.wantsFormCopy"
                    name="wantsFormCopy"
                    [value]="true"
                    (ngModelChange)="saveFormData()"
                    (focus)="trackFieldInteraction('wantsFormCopy_yes')"
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    [(ngModel)]="form.wantsFormCopy"
                    name="wantsFormCopy"
                    [value]="false"
                    (ngModelChange)="saveFormData()"
                  />
                  No
                </label>
              </div>
            </div>

            <!-- File Upload Section -->
            <div class="form-group file-upload-section">
              <div class="section-label">
                {{
                  "GENERAL_OUTREACH_FORM.FORM_FIELDS.UPLOAD_DOCUMENTS"
                    | translate
                }}
                <span class="optional-label"
                  >({{
                    "GENERAL_OUTREACH_FORM.LABELS.OPTIONAL" | translate
                  }})</span
                >
              </div>
              <p class="file-upload-description">
                {{
                  "GENERAL_OUTREACH_FORM.NOTES.FILE_UPLOAD_DESCRIPTION"
                    | translate
                }}
              </p>

              <div class="file-upload-container">
                <input
                  type="file"
                  #fileInput
                  (change)="onFileSelect($event)"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                  [disabled]="selectedFiles.length >= 3"
                  multiple
                  style="display: none"
                />
                <button
                  type="button"
                  class="file-select-button"
                  (click)="fileInput.click()"
                  [disabled]="selectedFiles.length >= 3"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.SELECT_FILE" | translate }}
                </button>
                <span class="file-limit-text">
                  {{ selectedFiles.length }}/3
                  {{
                    "GENERAL_OUTREACH_FORM.LABELS.FILES_SELECTED" | translate
                  }}
                </span>
              </div>

              @if (fileUploadError) {
                <p class="error-message" style="margin-top: 10px">
                  {{ fileUploadError }}
                </p>
              }

              <!-- Display selected files -->
              @if (selectedFiles.length > 0) {
                <div class="selected-files-list">
                  @for (file of selectedFiles; track file.name) {
                    <div class="file-item">
                      <div class="file-info">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="file-icon"
                        >
                          <path
                            d="M11 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V8M11 2L17 8M11 2V8H17"
                            stroke="#334ea5"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="file-details">
                          <span class="file-name">{{ file.name }}</span>
                          <span class="file-size">{{
                            formatFileSize(file.size)
                          }}</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="remove-file-button"
                        (click)="removeFile(file.name)"
                        [attr.aria-label]="'Remove ' + file.name"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 4L4 12M4 4L12 12"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                      </button>
                    </div>
                  }
                </div>

                <!-- File Upload Consent Checkbox -->
                <div class="checkbox-group" style="margin-top: 1rem">
                  <label>
                    <input
                      type="checkbox"
                      [(ngModel)]="fileUploadConsent"
                      name="fileUploadConsent"
                      (change)="saveFormData()"
                      (focus)="trackFieldInteraction('fileUploadConsent')"
                    />
                    <span class="required">
                      {{
                        "GENERAL_OUTREACH_FORM.LABELS.FILE_CONSENT" | translate
                      }}
                    </span>
                  </label>
                </div>

                <!-- Terms of Use Checkbox -->
                <div class="checkbox-group" style="margin-top: 0.5rem">
                  <label>
                    <input
                      type="checkbox"
                      [(ngModel)]="termsOfUseConsent"
                      name="termsOfUseConsent"
                      (change)="saveFormData()"
                      (focus)="trackFieldInteraction('termsOfUseConsent')"
                    />
                    <span class="required">
                      {{
                        "GENERAL_OUTREACH_FORM.LABELS.AGREE_TERMS_OF_USE"
                          | translate
                      }}
                      <a
                        href="/terms-of-use"
                        target="_blank"
                        (click)="$event.stopPropagation()"
                        >{{
                          "GENERAL_OUTREACH_FORM.LABELS.TERMS_LINK" | translate
                        }}</a
                      >.
                    </span>
                  </label>
                </div>
              }
            </div>

            <fieldset class="form-group">
              <legend class="required">
                {{
                  "GENERAL_OUTREACH_FORM.SECTION_TITLES.CONSENT_REVIEW"
                    | translate
                }}
              </legend>
              <div class="checkbox-group">
                <label [class.disabled]="form.optOutCommunications">
                  <input
                    type="checkbox"
                    [(ngModel)]="form.consentToShare"
                    name="consentToShare"
                    [disabled]="form.optOutCommunications"
                    (ngModelChange)="
                      saveFormData(); onConsentChange('consentToShare')
                    "
                    (focus)="trackFieldInteraction('consentToShare')"
                  />
                  <span>{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.CONSENT_TO_SHARE"
                      | translate
                  }}</span>
                </label>

                <label [class.disabled]="form.consentToShare">
                  <input
                    type="checkbox"
                    [(ngModel)]="form.optOutCommunications"
                    name="optOutCommunications"
                    [disabled]="form.consentToShare"
                    (ngModelChange)="
                      saveFormData(); onConsentChange('optOutCommunications')
                    "
                  />
                  <span>{{
                    "GENERAL_OUTREACH_FORM.FORM_FIELDS.OPT_OUT_COMMUNICATIONS"
                      | translate
                  }}</span>
                </label>
              </div>
            </fieldset>

            <!-- Show submission error if any -->
            @if (submitError) {
              <div class="error-message-container" style="margin-top: 15px">
                <p class="error-message">{{ submitError }}</p>
                @if (submitFieldErrors.length > 0) {
                  <ul class="error-list">
                    @for (error of submitFieldErrors; track error) {
                      <li class="error-message">{{ error }}</li>
                    }
                  </ul>
                }
              </div>
            }

            <!-- Form actions with back and submit buttons -->
            <div class="form-actions">
              @if (currentSection > 0) {
                <button type="button" class="back-button" (click)="onBack()">
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.BACK" | translate }}
                </button>
              }

              <button
                type="submit"
                (click)="submitForm()"
                [disabled]="!isFormReadyToSubmit()"
              >
                @if (isSubmitting) {
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMITTING" | translate }}
                } @else {
                  {{ "GENERAL_OUTREACH_FORM.BUTTONS.SUBMIT" | translate }}
                }
              </button>
            </div>
          </div>
        }
      </form>
    </div>
  </div>
}

@if (showEmailVerificationPopup) {
  <div class="email-verification-popup">
    <div class="popup-content">
      <button
        class="close-button"
        (click)="closeEmailVerificationPopup()"
        aria-label="Close popup"
      >
        <img src="/assets/icons/close.svg" alt="Close" />
      </button>
      <h3>
        {{ "GENERAL_OUTREACH_FORM.MESSAGES.VERIFY_EMAIL_TITLE" | translate }}
      </h3>

      @if (!isEditingEmail && !isEmailVerificationSent) {
        <!-- Initial state - show email and Get OTP button -->
        <p class="email-confirmation">
          <span
            >{{ "GENERAL_OUTREACH_FORM.MESSAGES.EMAIL_SENT" | translate }}
            <strong>{{ form.email }}</strong></span
          >
          <a
            href="javascript:void(0)"
            class="edit-email-link"
            (click)="startEditingEmail()"
            aria-label="Change email address"
          >
            {{ "GENERAL_OUTREACH_FORM.MESSAGES.NOT_YOUR_EMAIL" | translate }}
          </a>
        </p>

        <!-- reCAPTCHA for email verification -->
        <div class="recaptcha">
          <app-google-recaptcha
            (recaptchaToken)="onPopupCaptchaTokenEmit($event)"
          ></app-google-recaptcha>
        </div>

        <!-- Get OTP button -->
        <button
          class="get-otp-button"
          (click)="sendEmailVerification()"
          [disabled]="!isGetOtpEnabled()"
        >
          {{ "GENERAL_OUTREACH_FORM.MESSAGES.GET_OTP" | translate }}
        </button>
      }

      @if (!isEditingEmail && isEmailVerificationSent) {
        <p class="email-sent-message">
          <span
            >{{ "GENERAL_OUTREACH_FORM.MESSAGES.EMAIL_SENT" | translate }}
            <strong>{{ form.email }}</strong></span
          >
          <a
            href="javascript:void(0)"
            class="edit-email-link"
            (click)="startEditingEmail()"
            aria-label="Change email address"
          >
            {{ "GENERAL_OUTREACH_FORM.MESSAGES.NOT_YOUR_EMAIL" | translate }}
          </a>
        </p>

        <div class="verification-code-input">
          <input
            [(ngModel)]="emailVerificationCode"
            name="verificationCode"
            placeholder="{{
              'GENERAL_OUTREACH_FORM.PLACEHOLDERS.ENTER_VERIFICATION_CODE'
                | translate
            }}"
            type="text"
            [class.invalid]="emailVerificationCode && !isOtpValid()"
            (input)="onOtpInput($event)"
          />
          <button (click)="verifyEmailCode()" [disabled]="!isOtpValid()">
            {{ "GENERAL_OUTREACH_FORM.MESSAGES.VERIFY" | translate }}
          </button>
        </div>

        @if (emailVerificationCode && !isOtpValid()) {
          <p class="error-message">{{ getOtpErrorMessage() }}</p>
        }

        <div class="resend-section">
          @if (!canResendEmail && resendCountdown > 0) {
            <p class="resend-timer">
              {{ "GENERAL_OUTREACH_FORM.MESSAGES.RESEND_TIMER" | translate }}
              {{ resendCountdown }}
              {{ "GENERAL_OUTREACH_FORM.MESSAGES.SECONDS" | translate }}
            </p>
          }
          @if (canResendEmail) {
            <button class="resend-button" (click)="resendVerificationEmail()">
              {{ "GENERAL_OUTREACH_FORM.MESSAGES.RESEND_CODE" | translate }}
            </button>
          }
        </div>
      }

      @if (isEditingEmail) {
        <div class="edit-email-form">
          <input
            [(ngModel)]="tempEmail"
            name="tempEmail"
            placeholder="Enter your email"
            [class.invalid]="tempEmail && !isTempEmailValid()"
          />
          <button
            (click)="updateEmail()"
            [disabled]="!tempEmail || !isTempEmailValid()"
          >
            {{ "GENERAL_OUTREACH_FORM.ACTIONS.UPDATE" | translate }}
          </button>
        </div>
        <a
          href="javascript:void(0)"
          class="edit-email-link"
          (click)="cancelEditingEmail()"
          aria-label="Cancel email edit"
        >
          {{ "GENERAL_OUTREACH_FORM.ACTIONS.CANCEL" | translate }}
        </a>
      }

      @if (emailVerificationError) {
        <p class="error-message">{{ emailVerificationError }}</p>
      }
    </div>
  </div>
}

<!-- File Upload Progress Modal -->
@if (showFileUploadProgress) {
  <div class="file-upload-progress-modal">
    <div class="modal-content">
      <h3>
        {{ "GENERAL_OUTREACH_FORM.MESSAGES.UPLOADING_FILES_TITLE" | translate }}
      </h3>
      <p class="upload-description">
        {{
          "GENERAL_OUTREACH_FORM.MESSAGES.UPLOADING_FILES_DESCRIPTION"
            | translate
        }}
      </p>

      <div class="upload-files-list">
        @for (upload of fileUploads; track upload.fileName) {
          <div class="upload-item">
            <div class="upload-header">
              <div class="file-info">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="file-icon"
                >
                  <path
                    d="M11 2H5C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V8M11 2L17 8M11 2V8H17"
                    stroke="#334ea5"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span class="file-name">{{ upload.fileName }}</span>
              </div>
              <div class="upload-status">
                @if (upload.status === "uploading") {
                  <span class="status-text uploading"
                    >{{ upload.progress }}%</span
                  >
                }
                @if (upload.status === "completed") {
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="success-icon"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="9"
                      stroke="#334ea5"
                      stroke-width="2"
                    />
                    <path
                      d="M6 10L9 13L14 7"
                      stroke="#334ea5"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                @if (upload.status === "error") {
                  <span class="status-text error">{{
                    "GENERAL_OUTREACH_FORM.MESSAGES.UPLOAD_FAILED" | translate
                  }}</span>
                }
              </div>
            </div>
            @if (upload.status === "uploading") {
              <div class="progress-bar">
                <div
                  class="progress-fill"
                  [style.width.%]="upload.progress"
                ></div>
              </div>
            }
            @if (upload.error) {
              <p class="upload-error">{{ upload.error }}</p>
            }
          </div>
        }
      </div>

      @if (allUploadsCompleted) {
        <div class="upload-complete-message">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="success-checkmark"
          >
            <circle cx="24" cy="24" r="22" stroke="#334ea5" stroke-width="4" />
            <path
              d="M14 24L20 30L34 16"
              stroke="#334ea5"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="completion-text">
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.FILES_UPLOADED_SUCCESS"
                | translate
            }}
          </p>
          <p class="redirect-text">
            {{
              "GENERAL_OUTREACH_FORM.MESSAGES.REDIRECTING_SHORTLY" | translate
            }}
          </p>
        </div>
      }
    </div>
  </div>
}

@if (isDemoMode) {
  <app-outreach-chat-bot></app-outreach-chat-bot>
}
